export default {
    "Project-Id-Version": "",
    "POT-Creation-Date": "2024-08-29T04:43:11.415Z",
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Edito",
    "PO-Revision-Date": "2024-08-29T04:43:11.765Z",
    "Language": "pl-PL",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "",
        "10": "",
        "...": "",
        "...nie znalazłeś bloku?": "",
        "...nie znalazłeś bloku? Dodaj nowy.": "",
        "' + file.filename + '": "",
        "' + func.name + '": "",
        "%0 z %1": "",
        "%0 znaków": "",
        "<Brak nazwy>": "",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "",
        "${el.text}": "",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "",
        "${getCurrentScope().label}": "",
        "${item.entityName}": "",
        "${item.text}": "",
        "${loading ? 'Ładowanie elementów...' : 'Nie znaleziono żadnych elementów.'}": "",
        "${permissions.canPublish ? 'Przejdź do publikacji' : 'Wyślij do publikacji'}": "",
        "${props.inputPlaceholder}": "",
        "${props.title}": "",
        "${statusIndex === 0 ? 'Powrót' : 'Powrót do edycji artykułu'}": "",
        "${str}": "",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "",
        "1 godzina": "",
        "1:1": "",
        "10 minut": "",
        "12 godzin": "",
        "15 minut": "",
        "2 dni": "",
        "2 miesiące": "",
        "2 tygodnie": "",
        "24 godziny": "",
        "3 dni": "",
        "3 godziny": "",
        "3 miesiące": "",
        "30 minut": "",
        "4 dni": "",
        "4:7": "",
        "5 dni": "",
        "5 minut": "",
        "6 dni": "",
        "6 godzin": "",
        "7:4": "",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "",
        "Adaptive sampling": "",
        "Administracja": "",
        "Administracja - Kraje": "",
        "Administracja - Miasta": "",
        "Administracja - Role": "",
        "Administracja - Stanowiska pracy": "",
        "Administracja - Użytkownicy": "",
        "Administracja - Województwa": "",
        "Administracja - Zespoły": "",
        "Administratorzy": "",
        "Adres": "",
        "Adres docelowy": "",
        "Adres domenowy": "",
        "Adres domeny": "",
        "Adres e-mail potwierdzony": "",
        "Adres email": "",
        "Adres email nadawcy": "",
        "Adres IP": "",
        "Adres IP: %0": "",
        "Adres kanoniczny": "",
        "Adres serwera": "",
        "Adres strony": "",
        "Adres url": "",
        "Adres URL": "",
        "Adres url do pliku wideo": "",
        "Adres URL profilu autora.": "",
        "Adres źródłowy": "",
        "Akcent": "",
        "Akceptacja": "",
        "Akceptacja dokumentów": "",
        "Akceptacja dokumentu": "",
        "Akceptacja komentarzy": "",
        "Akceptacja własnych dokumentów": "",
        "Akceptacja wszystkich dokumentów": "",
        "Akceptowalny typ plików": "",
        "Akceptowany format danych": "",
        "Akceptuj": "",
        "Akcja": "",
        "Akcje": "",
        "Aktualizacja: {0}": "",
        "Aktualizuj": "",
        "Aktualna sesja": "",
        "Aktualne hasło": "",
        "Aktualne urządzenie": "",
        "Aktualności": "",
        "Aktualności ze strony": "",
        "Aktywacja kont po rejestracji": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywne do": "",
        "Aktywne kanały komunikacji": "",
        "Aktywne od": "",
        "Aktywne sesje": "",
        "Aktywne teraz": "",
        "Aktywne zastępstwa": "",
        "Aktywne źródła": "",
        "Aktywni": "",
        "Aktywny": "",
        "Aktywuj": "",
        "Aktywuj przerwę techniczną w witrynie": "",
        "Aktywuj tłumaczenia": "",
        "Aktywuj zestaw inteligentnych narzędzi": "",
        "Alert": "",
        "Alfabetycznie": "",
        "Alias": "",
        "Alias został przepięty.": "",
        "Angielski": "",
        "Ankieta": "",
        "Ankiety": "",
        "Anonimizuj": "",
        "Anonimowy": "",
        "Anulowane": "",
        "Anuluj": "",
        "Anuluj edycję": "",
        "Aplikacja": "",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "",
        "Apple iPad": "",
        "Apple iPhone 5": "",
        "Apple iPhone 6": "",
        "application/json": "",
        "application/x-www-form-urlencoded": "",
        "Aranżacja alternatywna": "",
        "Aranżacja domyślna": "",
        "Aranżacja główna": "",
        "Aranżacja utowrzona przez": "",
        "Aranżacja została dodana.": "",
        "Aranżacja została opublikowana.": "",
        "Aranżacja została usunięta.": "",
        "Aranżacja została zachowana.": "",
        "Aranżacja została zaktualizowana.": "",
        "Aranżacje": "",
        "Archiwum": "",
        "Artykuł": "",
        "Artykuł otwarty": "",
        "Artykuł premium": "",
        "Artykuł Premium": "",
        "Artykuł sponsorowany": "",
        "Artykuły": "",
        "Artykuły ze statusem PRIORYTET": "",
        "Asset został aktywowany.": "",
        "Asset został wyłączony.": "",
        "Asystenci": "",
        "Asystent AI": "",
        "Asystent został dodany.": "",
        "Asystent został zaktualizowany.": "",
        "Asystenta AI": "",
        "Audio": "",
        "Automatyczna akceptacja": "",
        "Automatyczna akceptacja komentarzy zalogowanych użytkowników": "",
        "Automatyczna akceptacja wszystkich komentarzy": "",
        "Automatyczna publikacja galerii": "",
        "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "",
        "Automatyczny": "",
        "Automatyzacja": "",
        "Autor": "",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "",
        "Autor został dodany.": "",
        "Autor został usunięty.": "",
        "Autor został zaktualizowany.": "",
        "Autorzy": "",
        "Autorzy spoza bazy użytkowników": "",
        "Avatar": "",
        "Azure AD": "",
        "Azure AI": "",
        "Azure Application Insights": "",
        "Azure OpenAI": "",
        "Baner został dodany.": "",
        "Baner został zaktualizowany.": "",
        "Banery": "",
        "Banner został usunięty.": "",
        "Barwa tekstu": "",
        "Barwa tła": "",
        "Basic Auth": "",
        "Baza danych": "",
        "Baza danych tego klienta jest nieaktualna.": "",
        "Baza dokumentów": "",
        "Bazy danych": "",
        "Bez \"http(s)://\" i \"/\" na końcu.": "",
        "Bezpieczeństwo": "",
        "Bezpieczne połączenie SSL": "",
        "Bezpieczny adres URL": "",
        "Bieżący dokument": "",
        "Blik": "",
        "Blok aktywny": "",
        "Blok jest wyłączony dla tej witryny": "",
        "Blok unikalny może zostać użyty tylko raz": "",
        "Blok został usunięty.": "",
        "Blokada konta": "",
        "Blokada konta do": "",
        "Bloki": "",
        "Blokowanie kont": "",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "",
        "Błędne": "",
        "Błędny": "",
        "Błędy": "",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "",
        "Brak": "",
        "Brak artykułów": "",
        "Brak cech w grupie": "",
        "Brak cennika dla wybranego dostawcy.": "",
        "Brak czołówki": "",
        "Brak danych": "",
        "Brak dodanych kolumn": "",
        "Brak dodanych plików": "",
        "Brak działu nadrzędnego": "",
        "Brak elementów": "",
        "Brak etykiety": "",
        "Brak kategorii": "",
        "Brak kategorii nadrzędnej": "",
        "Brak kluczy": "",
        "Brak kolekcji": "",
        "Brak listy regulaminów": "",
        "Brak modułu": "",
        "Brak nowych powiadomień.": "",
        "Brak odpowiedzi": "",
        "Brak opcji": "",
        "Brak plików do dodania": "",
        "Brak potwierdzenia": "",
        "Brak powiązań": "",
        "Brak stron": "",
        "Brak strony nadrzędnej": "",
        "Brak wersji": "",
        "Brak wyboru": "",
        "Brak wybranych autorów": "",
        "Brak wyników": "",
        "Brak zdefiniowanych ról.": "",
        "Brak zdefiniowanych zespołów.": "",
        "Bramka SMS": "",
        "Browse files": "",
        "Browse links": "",
        "Brutto": "",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "",
        "Cache po stronie serwera": "",
        "Cache-Control": "",
        "Cecha została dodana.": "",
        "Cecha została usunięta.": "",
        "Cecha została zaktualizowana.": "",
        "Cechy": "",
        "Cechy odziedziczone po kategoriach nadrzędnych": "",
        "Cechy w grupie": "",
        "Cena": "",
        "Cena brutto": "",
        "Cena w dolarach sumy tokenów wejściowych i wyjściowych.": "",
        "Cena została wyłączona z historii.": "",
        "Cennik Azure OpenAI": "",
        "Cennik AzureAI": "",
        "Cennik OpenAI": "",
        "Centrum powiadomień": "",
        "Ceny dostawy": "",
        "Checkbox": "",
        "Chronologia zdarzeń": "",
        "Ciemny": "",
        "Client ID": "",
        "Client Secret": "",
        "CMS": "",
        "Co 10 dni": "",
        "Co 10 minut": "",
        "Co 12 godzin": "",
        "Co 15 minut": "",
        "Co 2 godziny": "",
        "Co 2 minuty": "",
        "Co 2 tygodnie": "",
        "Co 20 minut": "",
        "Co 3 godziny": "",
        "co 3 miesiące": "",
        "Co 3 miesiące": "",
        "co 30 dni": "",
        "Co 30 minut": "",
        "Co 4 miesiące": "",
        "Co 5 dni": "",
        "Co 5 minut": "",
        "Co 6 godzin": "",
        "co 6 miesięcy": "",
        "Co chcesz wygenerować?": "",
        "Co drugi dzień": "",
        "Co drugi miesiąc": "",
        "Co godzinę": "",
        "Co miesiąc": "",
        "Co minutę": "",
        "Co pół roku": "",
        "co rok": "",
        "Co rok": "",
        "Co tydzień": "",
        "Codziennie": "",
        "Connection String": "",
        "Coś poszło nie tak": "",
        "CRC": "",
        "Cron": "",
        "Cyfry": "",
        "Czas": "",
        "Czas dostawy": "",
        "Czas na slajd": "",
        "Czas na stronie": "",
        "Czas na zgłoszenie reklamacji (w dniach)": "",
        "Czas na zgłoszenie zwrotu (w dniach)": "",
        "Czas po jakim zamówienie wygaśnie": "",
        "Czas po jakim zamówienie zostanie anulowane": "",
        "Czas pomiędzy": "",
        "Czas trwania blokady": "",
        "Czas uruchomienia": "",
        "Czas został zaktualizowany.": "",
        "Czat z asystentem": "",
        "Czerwiec": "",
        "Częstotliwość odświeżania": "",
        "Członkowie zespołu": "",
        "Czołówka": "",
        "Czołówka została dodana.": "",
        "Czołówka została usunięta.": "",
        "Czołówka została zaktualizowana.": "",
        "Cztery kolumny": "",
        "Czwartek": "",
        "Czy aby na pewno chesz zrestartować aplikacje?": "",
        "Czy chcesz ją przywrócić?": "",
        "Czy na pewno chcesz usunąć widget?": "",
        "Czytać mogą tylko zalogowani użytkownicy": "",
        "Dalej": "",
        "DALL-E 3": "",
        "Dane": "",
        "Dane do faktury": "",
        "Dane formularza są przechowywane w obiekcie Entry.": "",
        "Dane klienta": "",
        "Dane osobowe": "",
        "Dane w tabeli": "",
        "Dane wejściowe": "",
        "Dane wyjściowe": "",
        "Darmowa dostawa": "",
        "Darmowa przesyłka od kwoty (brutto)": "",
        "Data": "",
        "Data akceptacji": "",
        "Data automatycznej akceptacji": "",
        "Data dezaktywacji": "",
        "Data do": "",
        "Data dodania": "",
        "Data i czas": "",
        "Data i godzina": "",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "",
        "Data modyfikacji": "",
        "Data modyfikacji:": "",
        "Data od": "",
        "Data odrzucenia": "",
        "Data opłacenia": "",
        "Data opuszczenia zespołu": "",
        "Data ostatniego użycia": "",
        "Data otrzymania": "",
        "Data publikacji": "",
        "Data publikacji:": "",
        "Data rejestracji": "",
        "Data rezygnacji": "",
        "Data rozpoczęcia": "",
        "Data subskrypcji": "",
        "Data uruchomienia": "",
        "Data uruchomienia (UTC)": "",
        "Data usunięcia": "",
        "Data utworzenia": "",
        "Data utworzenia aranżacji": "",
        "Data utworzenia wersji": "",
        "Data utworzenia: ": "",
        "Data użycia": "",
        "Data wprowadzenia": "",
        "Data wydania": "",
        "Data wygaśnięcia": "",
        "Data wylogowania": "",
        "Data wywołania": "",
        "Data zakończenia": "",
        "Data zalogowania": "",
        "Data zapisania się": "",
        "Data zapytania": "",
        "Data zdarzenia": "",
        "Data zgłoszenia": "",
        "Data: %0 | Status: %1": "",
        "Daty publikacji zostały zaktualizowane.": "",
        "Dedykowane": "",
        "DeepL": "",
        "Definicja": "",
        "Definicja (JSON)": "",
        "Definicja formularza znajduje się w obiekcie Form.": "",
        "Definicja szablonu": "",
        "DELETE: Usunięcie wpisu": "",
        "Design Studio": "",
        "Dev": "",
        "Dezaktywuj": "",
        "Dla procesu zakupowego": "",
        "Długość": "",
        "Długość czasu przechowywania": "",
        "Długość trwania sesji [min": "",
        "Dni": "",
        "Dni tygodnia w których jest wysyłane zamówienie": "",
        "do": "",
        "Do": "",
        "Do akceptacji": "",
        "do czasu ręcznego odblokowania": "",
        "Do poziomu": "",
        "Docelowa strona": "",
        "Docs": "",
        "Dodaj": "",
        "Dodaj aranżację": "",
        "Dodaj asystenta": "",
        "Dodaj automatyzacje": "",
        "Dodaj autora": "",
        "Dodaj baner": "",
        "Dodaj cechę": "",
        "Dodaj czołówkę": "",
        "Dodaj dni": "",
        "Dodaj do zespołu": "",
        "Dodaj do zestawu": "",
        "Dodaj dokument": "",
        "Dodaj dział": "",
        "Dodaj endpoint": "",
        "Dodaj etykietę": "",
        "Dodaj formularz": "",
        "Dodaj funkcję": "",
        "Dodaj galerię": "",
        "Dodaj gazetkę": "",
        "Dodaj grupę": "",
        "Dodaj grupę cech": "",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "",
        "Dodaj katalog": "",
        "Dodaj kategorie": "",
        "Dodaj kategorię": "",
        "Dodaj klienta": "",
        "Dodaj kolejne słowo": "",
        "Dodaj kolejny element": "",
        "Dodaj kolejny powód": "",
        "Dodaj komponent": "",
        "Dodaj kraj": "",
        "Dodaj link": "",
        "Dodaj moduł": "",
        "Dodaj nowa kategorię": "",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy": "",
        "Dodaj nowy folder": "",
        "Dodaj nowy katalog aby rozpocząć zarządzanie kategoriami.": "",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy tag": "",
        "Dodaj nowy wątek": "",
        "Dodaj odpowiedź": "",
        "Dodaj opinię": "",
        "Dodaj plik": "",
        "Dodaj pliki": "",
        "Dodaj podsumowanie": "",
        "Dodaj pozycję": "",
        "Dodaj przekierowanie": "",
        "Dodaj pytanie": "",
        "Dodaj rolę": "",
        "Dodaj rotator": "",
        "Dodaj scenariusz": "",
        "Dodaj sekcję": "",
        "Dodaj serwer": "",
        "Dodaj shortcode": "",
        "Dodaj sklep": "",
        "Dodaj slajd": "",
        "Dodaj slajder": "",
        "Dodaj słowo": "",
        "Dodaj sposób dostawy": "",
        "Dodaj sposób płatności": "",
        "Dodaj stawkę": "",
        "Dodaj stronę": "",
        "Dodaj synonimy": "",
        "Dodaj szablon": "",
        "Dodaj token": "",
        "Dodaj użytkownika": "",
        "Dodaj walutę": "",
        "Dodaj wartość": "",
        "Dodaj webhooka": "",
        "Dodaj wideo": "",
        "Dodaj widget": "",
        "Dodaj wiersz": "",
        "Dodaj witrynę": "",
        "Dodaj wpis": "",
        "Dodaj wpis w kalendarzu": "",
        "Dodaj zakres": "",
        "Dodaj zastępstwo": "",
        "Dodaj zespół": "",
        "Dodaj zestaw": "",
        "Dodaj źródło": "",
        "dodał": "",
        "dodane i edytowane przeze mnie": "",
        "Dodane pliki z sortowaniem": "",
        "Dodane przez": "",
        "Dodane przez moje zespoły": "",
        "Dodane przeze mnie": "",
        "Dodanie": "",
        "Dodanie aktualności": "",
        "Dodanie ankiety": "",
        "Dodanie aranżacji": "",
        "Dodanie artykułu": "",
        "Dodanie asystenta": "",
        "Dodanie autora": "",
        "Dodanie baneru": "",
        "Dodanie cechy": "",
        "Dodanie czołówki": "",
        "Dodanie dokumentu": "",
        "Dodanie działu": "",
        "Dodanie endpointu": "",
        "Dodanie etykiety": "",
        "Dodanie formularza": "",
        "Dodanie funkcji": "",
        "Dodanie galerii": "",
        "Dodanie gazetki": "",
        "Dodanie grupy": "",
        "Dodanie grupy cech": "",
        "Dodanie kategorii": "",
        "Dodanie klienta": "",
        "Dodanie komponentu": "",
        "Dodanie kraju": "",
        "Dodanie linku": "",
        "Dodanie linku wewnętrznego": "",
        "Dodanie modułu": "",
        "Dodanie opcji dostawy": "",
        "Dodanie opcji płatności": "",
        "Dodanie pakietu": "",
        "Dodanie pliku": "",
        "Dodanie poradnika": "",
        "Dodanie regulaminu": "",
        "Dodanie roli": "",
        "Dodanie rotatora": "",
        "Dodanie scenariusza": "",
        "Dodanie serwera": "",
        "Dodanie sklepów": "",
        "Dodanie slajdera": "",
        "Dodanie stawki": "",
        "Dodanie strony": "",
        "Dodanie szablonu": "",
        "Dodanie top tematu": "",
        "Dodanie użytkownika": "",
        "Dodanie waluty": "",
        "Dodanie wartości": "",
        "Dodanie webhooka": "",
        "Dodanie wideo": "",
        "Dodanie witryny": "",
        "Dodanie wpisu do kalendarza": "",
        "Dodanie zastępstwa": "",
        "Dodanie zespołu": "",
        "Dodanie zestawu regulaminów": "",
        "Dodanie źródła": "",
        "Dodanie źródła danych": "",
        "Dodano za dużo plików (maksymalnie %0).": "",
        "dodany": "",
        "Dodanych plików %0 (limit wynosi %1).": "",
        "Dodatkowe informacje": "",
        "Dodawanie": "",
        "Dodawanie dokumentów": "",
        "Dodawanie i edycja własnych dokumentów": "",
        "Dodawanie wartości dwóch kolumn": "",
        "Dokument": "",
        "Dokument %0": "",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "",
        "Dokument nie ma ustawionej daty publikacji.": "",
        "Dokument PDF": "",
        "Dokument tekstowy": "",
        "Dokument został dodany.": "",
        "Dokument został usunięty.": "",
        "Dokument został wysłany do publikacji.": "",
        "Dokument został zaktualizowany.": "",
        "Dokumenty": "",
        "Dołącz stack trace": "",
        "Dołącz stronę do pliku sitemap.xml": "",
        "Dołączanie plików": "",
        "Domena": "",
        "Domyślna": "",
        "Domyślna waluta": "",
        "Domyślna wartość": "",
        "Domyślna witryna": "",
        "Domyślne": "",
        "Domyślne filtry": "",
        "Domyślne ustawienie dla witryny": "",
        "Domyślnie ukryte": "",
        "Domyślnie widoczne": "",
        "Domyślny": "",
        "Domyślny limit (brutto)": "",
        "Domyślny tytuł aktywnej strony": "",
        "Dopuść brak odpowiedzi": "",
        "Dostawa w godzinach wieczornych": "",
        "Dostawa w sobotę": "",
        "Dostawca": "",
        "Dostawy": "",
        "Dostawy i płatności": "",
        "Dostęp do modułu": "",
        "Dostęp niezdefiniowany": "",
        "Dostęp przyznany": "",
        "Dostęp zabroniony": "",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
        "Dostępna jest zapisana wersja robocza dokumentu.": "",
        "Dostępne": "",
        "Dostępne bloki": "",
        "Dostępne dla": "",
        "Dostępne języki": "",
        "Dostępne moduły": "",
        "Dostępne wersje językowe.": "",
        "Dostępny limit": "",
        "Dostępny w sekcjach": "",
        "Dotpay": "",
        "dowolnej wybranej wersji": "",
        "Dowolny": "",
        "Dozwolone rozszerzenia": "",
        "Dozwolone rozszerzenia plików": "",
        "Dozwolone rozszerzenia: %0.": "",
        "Dozwolone są tylko małe i duże litery": "",
        "Dozwolone są tylko małe litery i znak -": "",
        "Dozwolone typy plików: %0.": "",
        "Drugi klucz - md5": "",
        "Drugi klucz (MD5)": "",
        "Drugie imię": "",
        "Drugie powiadomienie": "",
        "Dsn": "",
        "Duplikuj": "",
        "Duże litery": "",
        "Duży": "",
        "Duży układ siatki": "",
        "Dwie kolumny": "",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywy zakresu": "",
        "Dział aktywny": "",
        "Dział nadrzędny": "",
        "Dział został dodany.": "",
        "Dział został zaktualizowany.": "",
        "Działania masowe": "",
        "Działanie modułu w oparciu o": "",
        "Dzielenie": "",
        "dzień": "",
        "E-mail": "",
        "Edycja": "",
        "Edycja aktualności": "",
        "Edycja ankiety": "",
        "Edycja aranżacji": "",
        "Edycja artykułu": "",
        "Edycja asystenta": "",
        "Edycja autora": "",
        "Edycja baneru": "",
        "Edycja cechy": "",
        "Edycja czołówki": "",
        "Edycja dokumentów": "",
        "Edycja dokumentu": "",
        "Edycja działu": "",
        "Edycja endpointu": "",
        "Edycja etykiety": "",
        "Edycja formularza": "",
        "Edycja funkcji": "",
        "Edycja galerii": "",
        "Edycja gazetki": "",
        "Edycja grupy": "",
        "Edycja grupy cech": "",
        "Edycja kategorii": "",
        "Edycja klienta": "",
        "Edycja komentarza": "",
        "Edycja komponentu": "",
        "Edycja kraju": "",
        "Edycja linku": "",
        "Edycja linku wewnętrznego": "",
        "Edycja logów": "",
        "Edycja modułu": "",
        "Edycja opcji dostawy": "",
        "Edycja opcji płatności": "",
        "Edycja pakietu": "",
        "Edycja pliku": "",
        "Edycja poradnika": "",
        "Edycja regulaminu": "",
        "Edycja roli": "",
        "Edycja rotatora": "",
        "Edycja scenariusza": "",
        "Edycja serwera": "",
        "Edycja sklepów": "",
        "Edycja slajdera": "",
        "Edycja stawki": "",
        "Edycja strony": "",
        "Edycja szablonu": "",
        "Edycja top tematu": "",
        "Edycja ustawień": "",
        "Edycja użytkownika": "",
        "Edycja w popupie": "",
        "Edycja waluty": "",
        "Edycja webhooka": "",
        "Edycja wideo": "",
        "Edycja witryny": "",
        "Edycja wpisu do kalendarza": "",
        "Edycja wszystkich dokumentów": "",
        "Edycja zastępstwa": "",
        "Edycja zespołu": "",
        "Edycja zestawu regulaminów": "",
        "Edycja źródła": "",
        "Edycja źródła danych": "",
        "Edytor": "",
        "Edytor lokalizowany": "",
        "Edytowana wersja": "",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "",
        "Edytuj": "",
        "Edytuj blok": "",
        "Edytuj członka grupy": "",
        "Edytuj dashboard": "",
        "Edytuj dokument": "",
        "Edytuj filtr": "",
        "Edytuj katalog": "",
        "Edytuj kategorię": "",
        "Edytuj komentarz": "",
        "Edytuj obszar": "",
        "Edytuj rotator": "",
        "Edytuj slajder": "",
        "Edytuj stronę": "",
        "Edytuj szablon": "",
        "Edytuj tag": "",
        "Edytuj uprawnienia": "",
        "Edytuj wpis": "",
        "Edytuj zestaw": "",
        "Eksport": "",
        "Eksport do Excela": "",
        "Eksport dokumentów": "",
        "Eksport użytkowników": "",
        "Element został przywrócony.": "",
        "Element został usunięty.": "",
        "Email": "",
        "Email potwierdzony": "",
        "Email użytkownika": "",
        "Email z linkiem został wysłany.": "",
        "Endpoint został dodany.": "",
        "Endpoint został zaktualizowany.": "",
        "Eskportuj": "",
        "Etykieta": "",
        "Etykieta została dodana.": "",
        "Etykieta została usunięta.": "",
        "Etykieta została zaktualizowana.": "",
        "Etykiety": "",
        "Export": "",
        "Exportuj do Excela": "",
        "Facebook Admins": "",
        "Facebook Application ID": "",
        "FavIcona": "",
        "Film": "",
        "Film z multimedia": "",
        "Film z YouTube": "",
        "Filmy": "",
        "Filtr dla synchronizacji działów": "",
        "Filtr dla synchronizacji użytkowników": "",
        "Filtr domyślny": "",
        "Filtr prywatny": "",
        "Filtr został usunięty": "",
        "Filtr został zapisany": "",
        "Filtrowanie": "",
        "Filtrowanie listy dokumentów": "",
        "Filtry": "",
        "Firebase": "",
        "Firebase config": "",
        "Firma": "",
        "Folder plików": "",
        "Folder został usunięty.": "",
        "Foldery": "",
        "Forma płatności": "",
        "Format ceny": "",
        "Format kodu pocztowego": "",
        "Format kodu powinien być wyrażeniem regularnym": "",
        "Format pliku": "",
        "Formularz": "",
        "Formularz bazuje na nieaktualnej wersji definicji.": "",
        "Formularz dynamiczny": "",
        "Formularz zarchiwizowany": "",
        "Formularz został dodany.": "",
        "Formularz został skopiowany.": "",
        "Formularz został zaakceptowany.": "",
        "Formularz został zaktualizowany.": "",
        "Formularze": "",
        "Formuła jest nieprawidłowa": "",
        "Fraza": "",
        "Funkcja została dodana.": "",
        "Funkcja została usunięta.": "",
        "Funkcja została zaktualizowana.": "",
        "Funkcje": "",
        "Funkcje asystenta": "",
        "Funkcjonalności": "",
        "Galeria": "",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "",
        "Galeria nie ma ustawionej daty publikacji.": "",
        "Galeria zdjęć": "",
        "Galeria zdjęć premium": "",
        "Galeria została dodana.": "",
        "Galeria została usunięta.": "",
        "Galeria została zaktualizowana.": "",
        "Gazetka": "",
        "Gazetka nie jest jeszcze nigdzie opublikowana.": "",
        "Gazetka nie ma ustawionej daty publikacji.": "",
        "Gazetka została dodana.": "",
        "Gazetka została usunięta.": "",
        "Gazetka została zaktualizowana.": "",
        "Generator obrazów AI": "",
        "Generowanie formularza zakończone.": "",
        "Generowanie obrazów": "",
        "Generowanie obrazów zakończone.": "",
        "Generowanie stron gazetek...": "",
        "Generuj": "",
        "Generuj formularz": "",
        "Generuj metadane": "",
        "Generuj metadane (AI)": "",
        "Generuj nowe sitemapy": "",
        "Generuj nowy obraz": "",
        "Generuj obraz": "",
        "Generuj strony gazetki": "",
        "Generuj wszystkie metadane": "",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "",
        "GET: Pobranie danych": "",
        "GET: Pobranie wpisu": "",
        "GET: Schemat (definicja formularza)": "",
        "Godzina wysyłki zamówień": "",
        "Godziny": "",
        "Google Nexus 10": "",
        "Google Nexus 5": "",
        "Google Nexus 7": "",
        "Google Translate V2": "",
        "GPT-4 Vision": "",
        "GPT-4o Omni": "",
        "Grafika": "",
        "Grafika wektorowa": "",
        "Grudzień": "",
        "Grupa": "",
        "Grupa banerów została dodana.": "",
        "Grupa banerów została usunięta.": "",
        "Grupa banerów została zaktualizowana.": "",
        "Grupa cech została dodana.": "",
        "Grupa cech została usunięta.": "",
        "Grupa cech została zaktualizowana.": "",
        "Grupy": "",
        "Grupy cech": "",
        "Harmonogram zadań": "",
        "Harmonogram został zmieniony": "",
        "Hasło": "",
        "Hasło (Klucz ukryty)": "",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "",
        "Hasło użytkownika": "",
        "Hasło użytkownika serwisowego": "",
        "Hasło zostało zmienione. Zaloguj się ponownie": "",
        "Health": "",
        "Hierarchia": "",
        "Historia": "",
        "Historia cen": "",
        "Historia logowania": "",
        "Historia zadania": "",
        "Historia zapytań do AI": "",
        "Host": "",
        "Host dodatkowy": "",
        "Host główny": "",
        "i": "",
        "i posiadających wymagane uprawnienia": "",
        "Id": "",
        "ID": "",
        "ID lub typ zadania": "",
        "Id modelu: %0": "",
        "Id obiektu": "",
        "Id punktu płatności - posId": "",
        "Id punktu płatności (pos_id)": "",
        "Id sesji": "",
        "ID sklepu": "",
        "Id wpisu": "",
        "ID zadania": "",
        "Id zapytania": "",
        "Id zdarzenia": "",
        "Identyfikator": "",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "",
        "Identyfikator sprzedawcy": "",
        "Identyfikator wdrożenia": "",
        "Identyfikator zadania": "",
        "Ikona": "",
        "Ikona wartości": "",
        "Ikona wyświetlana jest w postaci kwadratu.": "",
        "Ile dni przed zakończeniem subskrypcji autoodnawialnej rozpocznie się pobranie płatności": "",
        "Ile razy system ponawia płatność": "",
        "Ilość artykułów w kategorii": "",
        "Ilość dostępnych bloków": "",
        "Ilość produktu jaka ma zostać w magazynie. W pierwszej kolejności brana po uwagę jest wartość z wariantu, następnie z produktu a na końcu z kategorii.": "",
        "Ilość wierszy": "",
        "Ilość wyników do odrzucenia": "",
        "Ilość wyników do pobrania": "",
        "Ilość wyświetlanych aktualności": "",
        "Ilość wyświetlanych artykułów": "",
        "Ilość wyświetlanych tagów": "",
        "Ilość znaków": "",
        "Ilość znaków odpowiedzi": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Imię i nazwisko/nazwa autora": "",
        "Import": "",
        "Import modułu": "",
        "Import użytkowników": "",
        "Importuj definicję formularza": "",
        "Indeks": "",
        "Indeks został usunięty.": "",
        "Indeksowanie strony": "",
        "Informacja": "",
        "Informacja o błędzie": "",
        "Informacja o ciasteczkach": "",
        "Informacje o zamówieniu": "",
        "Inspekcja": "",
        "Instalacja": "",
        "Instrukcja": "",
        "Instrukcja modelu (prompt).": "",
        "Interakcja użytkownika (Komenatrze, Like)": "",
        "Interpreter kodu": "",
        "Interpreter kodu umożliwia asystentowi pisanie i uruchamianie kodu. To narzędzie może przetwarzać pliki z różnymi danymi i formatowaniem oraz generować pliki.": "",
        "ISBN": "",
        "Jakość": "",
        "Jakość HD": "",
        "Jakość standardowa": "",
        "Jakość wygnerowanego obrazu.": "",
        "Jasny": "",
        "Jedna kolumna": "",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "",
        "Jeśli nazwa wyświetlana nie zostanie ustawiona, to zostanie użyta nazwa kategorii.": "",
        "Jeśli pole jest puste to wstawiana automatycznie.": "",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "",
        "Język": "",
        "Język domyślny": "",
        "Kalendarz": "",
        "Kalendarz - Kategorie zasobów": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "",
        "kanał wymagany": "",
        "Kanały": "",
        "Kanały komunikacji": "",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "",
        "Kanały włączone w ustawieniach aplikacji": "",
        "Karta": "",
        "Katalog": "",
        "Katalog główny": "",
        "Katalog linków": "",
        "Katalog został usunięty.": "",
        "Katalog został utworzony": "",
        "Katalog został utworzony.": "",
        "Katalogi kategorii": "",
        "Kategoria": "",
        "Kategoria jest wymagana": "",
        "Kategoria linku": "",
        "Kategoria nadrzędna": "",
        "Kategoria opublikowana": "",
        "Kategoria subskrypcji": "",
        "Kategoria subskrypcji została dodana.": "",
        "Kategoria subskrypcji została usunięta.": "",
        "Kategoria subskrypcji została zaktualizowana.": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Kategorie linków": "",
        "Kategorię": "",
        "Kategorię można opublikować tylko na jednej stronie.": "",
        "Kategorię subskrypcji": "",
        "Key": "",
        "Key pair": "",
        "Klienci": "",
        "Klient aktywny": "",
        "Klient został dodany.": "",
        "Klient został usunięty.": "",
        "Klient został zaktualizowany.": "",
        "Klucz": "",
        "Klucz API": "",
        "Klucz prywatny": "",
        "Klucz publiczny": "",
        "Klucze": "",
        "Klucze są nie prawidłowe.": "",
        "Klucze są prawidłowe.": "",
        "Kobieta": "",
        "Kod bannera (tutaj wklej kod HTML i JS)": "",
        "Kod Bing Webmaster": "",
        "Kod Google Webmaster": "",
        "Kod GTM": "",
        "Kod HTML": "",
        "Kod ISO": "",
        "Kod pocztowy": "",
        "Kod walidacji": "",
        "Kod wertfikacyjny": "",
        "Kod weryfikacyjny jest nieprawidłowy.": "",
        "Kod został skopiowany do schowka.": "",
        "Kod źródłowy": "",
        "Kolejka": "",
        "Kolejne pozycje z lewej strony": "",
        "Kolejne pozycje z prawej strony": "",
        "Kolor drugorzędny: %0": "",
        "Kolor icon na panelu z aplikacjami: %0": "",
        "Kolor podstawowy: %0": "",
        "Kolor przewodni obrazu": "",
        "Kolor tekstu": "",
        "Kolor tekstu aktywnej pozycji menu: %0": "",
        "Kolor tła": "",
        "Kolor tła panelu z aplikacjami: %0": "",
        "Kolory zostały przywrócone.": "",
        "Kolory zostały zapisane.": "",
        "Kolumna": "",
        "Kolumny": "",
        "Komentarz": "",
        "Komentarz %0": "",
        "Komentarz do wyłączenia ceny": "",
        "Komentarze": "",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "",
        "Komponent relacyjny": "",
        "Komponent został dodany.": "",
        "Komponent został usunięty.": "",
        "Komponent został zaktualizowany.": "",
        "Komponent źródłowy": "",
        "Komponenty": "",
        "Komunikat": "",
        "Komunikat błędu": "",
        "Komunikat mailowy": "",
        "Komunikat walidacji": "",
        "Konfiguracja": "",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja asystenta ai": "",
        "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja bloku": "",
        "Konfiguracja bloku została zapisana.": "",
        "Konfiguracja domyślna": "",
        "Konfiguracja harmonogramu (czas UTC)": "",
        "Konfiguracja kolumn tabeli": "",
        "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "",
        "Konfiguracja zaawansowana": "",
        "Konfiguracja zapytania": "",
        "Konfiguruj kategorię": "",
        "Konfiguruj stronę": "",
        "Konta użytkowników": "",
        "Konta użytkowników zostały odblokowane": "",
        "Konta użytkowników zostały przypisane do zespołu": "",
        "Konta użytkowników zostały usunięte z systemu": "",
        "Konta użytkowników zostały zablokowane": "",
        "Kontakt": "",
        "Kontakty - Typ działania": "",
        "Kontener plików": "",
        "Konto aktywne": "",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
        "Konto publiczne": "",
        "Konto z dostępem do panelu administracyjnego": "",
        "Konto zanonimizowane": "",
        "Kontrolka": "",
        "Kontrolka wyboru (pojedynczy wybór)": "",
        "Kontrolka wyboru (wybór wielokrotny)": "",
        "Konwertuj obrazy do formatu WebP": "",
        "Kopiuj": "",
        "Kopiuj adres": "",
        "Kopiuj definicję": "",
        "Kopiuj pole": "",
        "Kosz": "",
        "Koszt płatności netto": "",
        "Kraj": "",
        "Kraj został dodany.": "",
        "Kraj został zaktualizowany.": "",
        "Kraje": "",
        "Krok minut": "",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "",
        "Kroki": "",
        "Krótki opis": "",
        "Krótki tytuł": "",
        "Książka": "",
        "Kurs": "",
        "Kwiecień": "",
        "Laptop 15,6\"": "",
        "Laptop 15\"": "",
        "Laptop 17\"": "",
        "LDAPS (LDAP over SSL)": "",
        "Legacy": "",
        "Lewy panel": "",
        "Licencja": "",
        "Liczba": "",
        "Liczba artykułów": "",
        "Liczba całkowita": "",
        "Liczba danych wejściowych podana w tokenach.": "",
        "Liczba danych wyjściowych podana w tokenach.": "",
        "Liczba dni przechowywania": "",
        "Liczba dziesiętna": "",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "",
        "Liczba wariantów": "",
        "Liczba wyników na stronie": "",
        "Liczba wyświetlanych najnowszych elementów": "",
        "Liczba wyświetlanych slajdów": "",
        "Liczba wyświetleń": "",
        "Liczba zamówień": "",
        "Liczba zgłoszeń:": "",
        "Lider": "",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "",
        "Limit": "",
        "Limit API": "",
        "Limit czasowy rezerwacji (w minutach)": "",
        "Limit konta OpenAI": "",
        "Limit kupiecki": "",
        "Limit usług AI": "",
        "Limit zgłoszeń": "",
        "Limit znaków dla niezalogowanych": "",
        "Limit znaków dla zalogowanych": "",
        "Limity": "",
        "Linia": "",
        "linie": "",
        "Link": "",
        "Link do strony": "",
        "Link do wybranej strony serwisu": "",
        "Link do zewnętrznej strony": "",
        "Link wewnętrzny został dodany.": "",
        "Link wewnętrzny został usunięty.": "",
        "Link wewnętrzny został zaktualizowany.": "",
        "Link wygasł": "",
        "Link z serwisu": "",
        "Link został dodany.": "",
        "Link został usunięty.": "",
        "Link został zaktualizowany.": "",
        "Linki wewnętrzne": "",
        "Linki wewnętrzne zostały pomyślnie połączone.": "",
        "Lipiec": "",
        "Lista artykułów": "",
        "Lista banerów": "",
        "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "",
        "Lista dozwolonych / wykluczonych żądań HTTP": "",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "",
        "Lista ID": "",
        "Lista indeksów": "",
        "Lista jest pusta": "",
        "Lista komentarzy": "",
        "Lista linków": "",
        "Lista plików": "",
        "Lista powiadomień": "",
        "Lista regulaminów": "",
        "Lista rozszerzeń oddzielona przecinkami.": "",
        "Lista rozwijana": "",
        "Lista sitemap": "",
        "Lista zaufanych adresów IP": "",
        "Listopad": "",
        "Listy": "",
        "Litery": "",
        "Litery i cyfry": "",
        "Logi": "",
        "Logi wydajnościowe": "",
        "Login": "",
        "Logo": "",
        "Logowanie": "",
        "Logowanie zakończyło się niepowodzeniem.": "",
        "Logowanie zależności / żądań typu HTTP": "",
        "Loguj wybrane": "",
        "Lokalizowane": "",
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit.": "",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit.": "",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.": "",
        "Luty": "",
        "Ładowanie zgłoszeń...": "",
        "Łączenie treści": "",
        "Maj": "",
        "Maksimum": "",
        "Maksymalna głębokość": "",
        "Maksymalna ilość plików": "",
        "Maksymalna liczba produktów": "",
        "Maksymalna rozdzielość %0x%1px": "",
        "Maksymalna szerokość": "",
        "Maksymalna szerokość strony to 1410": "",
        "Maksymalna waga": "",
        "Maksymalna waga zamówienia": "",
        "Maksymalna wartość zamówienia (brutto)": "",
        "Maksymalna wysokość": "",
        "Maksymalna wysokość strony to 1080": "",
        "Maksymalny rozmiar pliku w MB": "",
        "Maksymalny rozmiar pliku: %0MB.": "",
        "Maksymalny rozmiar pojedynczego pliku": "",
        "Małe litery": "",
        "Małe znaki": "",
        "Mały": "",
        "Mały układ siatki": "",
        "Mappingi": "",
        "Margines dla produktów": "",
        "Marketing": "",
        "Marzec": "",
        "Metadane": "",
        "Metoda": "",
        "Metoda autentykacji": "",
        "Metoda musi zwracać obiekt \"entry.errors\".": "",
        "Mężczyzna": "",
        "Miasto": "",
        "Miejsca po przecinku": "",
        "Miejscowość": "",
        "miesiąc": "",
        "Miesiąc": "",
        "Miesiące": "",
        "Migracje": "",
        "Miniaturka": "",
        "Miniaturki": "",
        "Minimalna długość hasła": "",
        "Minimalna ilość plików": "",
        "Minimalna szerokość strony to 370": "",
        "Minimalna wysokość strony to 500": "",
        "Minimum": "",
        "Minuty": "",
        "Mnożenie": "",
        "Mnożnik": "",
        "Model": "",
        "Model danych": "",
        "Moderacja włączona": "",
        "Moderacja wyłączona": "",
        "Moduł": "",
        "Moduł dynamiczny": "",
        "Moduł konfigurowalny": "",
        "Moduł płatności": "",
        "Moduł został dodany.": "",
        "Moduł został usunięty.": "",
        "Moduł został wyeksportowany.": "",
        "Moduł został zaktualizowany.": "",
        "Moduły": "",
        "Moduły wyszukiwarki": "",
        "Modyfikacja": "",
        "Modyfikacja dokumentów": "",
        "Modyfikuj istniejący wątek": "",
        "Moje dokumenty": "",
        "Moje filtry": "",
        "Moje konto": "",
        "Moje pliki": "",
        "Monitor kolejek": "",
        "Monitoring": "",
        "Monitoruj statystyki .NET": "",
        "Monitoruj żądania HTTP": "",
        "Możesz podać nową nazwę pliku.": "",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość wielokrotnego wyboru": "",
        "Multimedia": "",
        "Multimedia premium": "",
        "multipart/form-data": "",
        "Na pewno usunąć wybrane elementy?": "",
        "Naciśnij enter aby usunąć": "",
        "Naciśnij enter aby wybrać": "",
        "Nadawanie uprawnień do dokumentów": "",
        "Nadawanie uprawnień do własnych dokumentów": "",
        "Nadawanie uprawnień do wszystkich dokumentów": "",
        "Nadawca": "",
        "Nagłówek": "",
        "Nagłówek dokumentu": "",
        "Najniższa cena brutto z 30 dni przed obniżką": "",
        "Najniższy": "",
        "Najpierw dodaj stronę do gazetki.": "",
        "Najstarsza wiadomość": "",
        "Najwyższy": "",
        "Narzędzia": "",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "",
        "Narzędzie integruje się z platformą SMSAPI.pl": "",
        "Następna strona": "",
        "Nazwa": "",
        "Nazwa aktywnej strony": "",
        "Nazwa aliasu": "",
        "Nazwa aranżacji": "",
        "Nazwa asystenta": "",
        "Nazwa bazy danych": "",
        "Nazwa bloku": "",
        "Nazwa cechy": "",
        "Nazwa certyfikatu": "",
        "Nazwa czołówki": "",
        "Nazwa działu": "",
        "Nazwa etykiety": "",
        "Nazwa filtra": "",
        "Nazwa formularza": "",
        "Nazwa funkcji": "",
        "Nazwa grupy": "",
        "Nazwa grupy cech": "",
        "Nazwa jest wymagana": "",
        "Nazwa katalogu": "",
        "Nazwa katalogu została zmieniona.": "",
        "Nazwa kategorii": "",
        "Nazwa Kategorii": "",
        "Nazwa klienta": "",
        "Nazwa kolumny": "",
        "Nazwa kolumny z opisem": "",
        "Nazwa kolumny z wartością": "",
        "Nazwa komponentu": "",
        "Nazwa konta (Klucz dostępu)": "",
        "Nazwa linku": "",
        "Nazwa modelu": "",
        "Nazwa modułu": "",
        "Nazwa musi mieć co najmniej 3 znaki": "",
        "Nazwa musi mieć co najmniej 5 znaków": "",
        "Nazwa nadawcy": "",
        "Nazwa narzędzia": "",
        "Nazwa nie może być dłuższa niż 30 znaków": "",
        "Nazwa nie może być dłuższy niż 50 znaków": "",
        "Nazwa pakietu": "",
        "Nazwa pliku": "",
        "Nazwa pliku została zmieniona.": "",
        "Nazwa płyty": "",
        "Nazwa pola": "",
        "Nazwa powiadomienia": "",
        "Nazwa przycisku ``Dalej``": "",
        "Nazwa przycisku ``Wstecz``": "",
        "Nazwa przycisku ``Wyślij``": "",
        "Nazwa roli": "",
        "Nazwa rotatora": "",
        "Nazwa sekcji": "",
        "Nazwa sekcji w menu": "",
        "Nazwa sekcji...": "",
        "Nazwa serwera": "",
        "Nazwa slajdera": "",
        "Nazwa slajdu": "",
        "Nazwa sposobu dostawy": "",
        "Nazwa sposobu płatności": "",
        "Nazwa strony": "",
        "Nazwa szablonu": "",
        "Nazwa typu": "",
        "Nazwa urządzenia": "",
        "Nazwa użytkownika": "",
        "Nazwa użytkownika serwisowego": "",
        "Nazwa w panelu": "",
        "Nazwa wątku": "",
        "Nazwa webhooka": "",
        "Nazwa wewnętrzna": "",
        "Nazwa witryny": "",
        "Nazwa wpisu do kalendarza": "",
        "Nazwa wyświetlana": "",
        "Nazwa wyświetlana:": "",
        "Nazwa zadania": "",
        "Nazwa zasobu": "",
        "Nazwa zespołu": "",
        "Nazwa zestawu": "",
        "Nazwa źródła": "",
        "Nazwa źródła danych": "",
        "Nazwa:": "",
        "Nazwisko": "",
        "Nazwy wartości": "",
        "Netto": "",
        "Nie": "",
        "Nie loguj wybranych": "",
        "Nie ma jeszcze żadnych kategorii.": "",
        "Nie masz uprawnień do modyfikacji aranżacji.": "",
        "Nie masz uprawnień do panelu administracyjnego.": "",
        "Nie masz uprawnień do publikacji aranżacji.": "",
        "Nie masz uprawnień do tego dokumentu": "",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "",
        "Nie możesz dodać tego samego widgetu dwa razy": "",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "",
        "Nie możesz modyfikować uprawnień": "",
        "Nie można już edytować tego linku wewnętrznego, ponieważ jest on aktualnie używany.": "",
        "Nie można usunąć swojego konta.": "",
        "Nie podano wymaganej ilości znaków: %0.": "",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "",
        "Nie posiadasz uprawnień do edycji tego artykułu.": "",
        "Nie pozwól zamówić": "",
        "Nie udało się pobrać kategorii": "",
        "Nie udało się pobrać listy aranżacji": "",
        "Nie udało się pobrać listy bloków": "",
        "Nie udało się pobrać listy działów": "",
        "Nie udało się pobrać listy etykiet": "",
        "Nie udało się pobrać listy filtrów": "",
        "Nie udało się pobrać listy kanałów": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się pobrać listy kolejek": "",
        "Nie udało się pobrać listy modułów": "",
        "Nie udało się pobrać listy modułów wyszukiwarki": "",
        "Nie udało się pobrać listy powiadomień": "",
        "Nie udało się pobrać listy regulaminów": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy serwerów baz danych": "",
        "Nie udało się pobrać listy serwerów plików": "",
        "Nie udało się pobrać listy stron": "",
        "Nie udało się pobrać listy szablonów": "",
        "Nie udało się pobrać listy typów modeli": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie udało się pobrać listy zespołów": "",
        "Nie udało się pobrać obrazu.": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się pobrać ustawień kont użytkowników": "",
        "Nie udało się pobrać widgetu/ów": "",
        "Nie udało się usunąć szablonu": "",
        "Nie udało się wczytać podglądu strony.": "",
        "Nie udało się wygenerować formularza": "",
        "Nie udało się wykonać akcji": "",
        "Nie udało się wysłać pliku": "",
        "Nie udało się załadować widgetu AI.": "",
        "Nie udało się zapisać filtra": "",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
        "Nie wybrano authora.": "",
        "Nie wybrano strony": "",
        "Nie wybrano żadnego użytkownika.": "",
        "Nie wybrano żadnej kategorii": "",
        "Nie wymaga uwierzytelniania": "",
        "nie wymuszaj zmiany hasła": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie zdefiniowano żadnych sekcji.": "",
        "Nie znaleziono dostępnych widgetów": "",
        "Nie znaleziono filtrów.": "",
        "Nie znaleziono formularza.": "",
        "Nie znaleziono kolumn.": "",
        "Nie znaleziono pasującego widgetu": "",
        "Nie znaleziono pasujących elementów.": "",
        "Nie znaleziono żadnego pola.": "",
        "Nie znaleziono żadnych folderów.": "",
        "Nie znaleziono żadnych plików": "",
        "Nie znaleziono żadnych użytkowników.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nieaktywne": "",
        "Nieaktywni": "",
        "Nieaktywny": "",
        "niedozwolone rozszerzenie pliku (%0)": "",
        "Niedozwolone słowa": "",
        "niedozwolony typ pliku (%0)": "",
        "Niedziela": "",
        "Niepoprawne wyrażenie regularne": "",
        "Niepotwierdzeni": "",
        "Nieprawidłowa definicja": "",
        "Nieprawidłowy adres email": "",
        "Nieprawidłowy adres URL": "",
        "Nieprzeczytane": "",
        "Niestandardowy adres": "",
        "Niestandardowy adres strony": "",
        "Niestandardowy błąd": "",
        "Niestandardowy nagłówek": "",
        "Nieudane": "",
        "Nieudane logowania": "",
        "Niewidoczne": "",
        "Nieznane narzędzie": "",
        "Nieznany model": "",
        "Nieznany typ pliku": "",
        "Nieznany widget": "",
        "Nigdy": "",
        "Nikomu nie przydzielono uprawnień": "",
        "NIP": "",
        "Niski": "",
        "Niżej": "",
        "no-store (wyłącza cache)": "",
        "Nofollow": "",
        "Nowa cena brutto": "",
        "Nowa cena do": "",
        "Nowa cena od": "",
        "Nowa data": "",
        "Nowe hasło": "",
        "Nowe sitemapy zostały wygenerowane.": "",
        "np. (&(objectClass=organizationalUnit))": "",
        "np. (&(objectClass=user)": "",
        "np. pl-PL": "",
        "Number": "",
        "Numer": "",
        "Numer aktywnej strony": "",
        "Numer budynku": "",
        "Numer domu": "",
        "Numer domu/mieszkania": "",
        "Numer kierunkowy": "",
        "Numer konta": "",
        "Numer mieszkania": "",
        "Numer sesji": "",
        "Numer telefonu": "",
        "OAuth2 dla Exchange Online": "",
        "Obiekt %0 został %1": "",
        "Obok siebie": "",
        "Obraz": "",
        "Obraz został pomyślnie opisany": "",
        "Obraz został wycięty.": "",
        "Obraz został wygenerowany.": "",
        "Obsługiwane formaty plików: txt, md, pdf, docx.": "",
        "Oczekujący na akceptację": "",
        "Oczekuje na płatność": "",
        "Oczekuje na potwierdzenie": "",
        "Oczekuje na wysłanie": "",
        "Oczekuje na zatwierdzenie": "",
        "od": "",
        "Od": "",
        "od %0": "",
        "Od poziomu": "",
        "Odbiorca": "",
        "Odbiorca (firma)": "",
        "Odblokuj": "",
        "Odejmowanie": "",
        "Odnośnik URL": "",
        "Odpowiedzi": "",
        "Odpowiedzi: %0 na %1": "",
        "Odpowiedź": "",
        "Odpowiedź dowolna": "",
        "Odrzucone": "",
        "Odrzucone zgody": "",
        "Odrzucony po zgłoszeniach": "",
        "Odrzuć": "",
        "Odstęp": "",
        "Odśwież": "",
        "Odznacz": "",
        "Odznacz wszystkie": "",
        "Ok": "",
        "Okładka": "",
        "Okładka do wideo premium": "",
        "Określa miejsce, w którym znajdzie się powiązany artykuł": "",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "",
        "Omnitool": "",
        "Opcja dodatkowa": "",
        "Opcje": "",
        "Open Graph": "",
        "OpenAI": "",
        "Operacje": "",
        "Operator płatności": "",
        "Opinia": "",
        "Opis": "",
        "Opis błędu": "",
        "Opis funkcji": "",
        "Opis obrazu": "",
        "Opis przerwy technicznej": "",
        "Opis sekcji": "",
        "Opis wartości": "",
        "Opis witryny": "",
        "Opis zespołu": "",
        "Opis źródła": "",
        "Opisy": "",
        "Opisz jaki formularz chcesz wygenerować": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Opublikowana": "",
        "Opublikowane": "",
        "Opublikowane języki": "",
        "Opublikowane wersje językowe.": "",
        "Opublikowany na stronach": "",
        "Opublikuj": "",
        "Opublikuj autora": "",
        "Oraz hasło": "",
        "Oraz nowe hasło": "",
        "Organizacja": "",
        "Organizacja została usunięta.": "",
        "Osoba zastępowana": "",
        "Osoba zastępująca": "",
        "Ostatnia aktualizacja:": "",
        "Ostatnia aktywność": "",
        "Ostatnia strona": "",
        "Ostrzeżenia": "",
        "Ostrzeżenie": "",
        "Oś czasu": "",
        "Otwieraj w nowym oknie": "",
        "Otwórz": "",
        "Otwórz stronę w nowym oknie": "",
        "Oznacz": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako opłacone": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Pakiet": "",
        "Pakiet aktywny": "",
        "Pakiet autoodnawialny": "",
        "Pakiet został dodany.": "",
        "Pakiet został zaktualizowany.": "",
        "Pakiety": "",
        "Paleta kolorów": "",
        "Państwo aktywne": "",
        "Parametry funkcji": "",
        "Parametry, wymagane do wykonania zapytania:": "",
        "Pasek": "",
        "Pasek postępu": "",
        "PayPal": "",
        "PayU": "",
        "Październik": "",
        "Pełna strona": "",
        "Pełna treść:": "",
        "Pełny": "",
        "Pełny adres aktywnej strony": "",
        "Pełny adres wraz z \"http(s)://\".": "",
        "Pełny ekran": "",
        "Piątek": "",
        "Pierwiastkowanie wartości kolumny": "",
        "Pierwsza strona": "",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "",
        "Pierwsze powiadomienie": "",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "",
        "Pigułki": "",
        "Piktogram": "",
        "PIN": "",
        "Piosenka": "",
        "Pisać mogą tylko zalogowani użytkownicy": "",
        "Plik": "",
        "Plik audio": "",
        "Plik binarny": "",
        "Plik CSS": "",
        "Plik CSV": "",
        "Plik DOC": "",
        "Plik DOCX": "",
        "Plik gazetki (PDF)": "",
        "Plik gazetki do pobrania (PDF)": "",
        "Plik GIF": "",
        "Plik graficzny": "",
        "Plik HTML": "",
        "Plik jest wysyłany": "",
        "Plik JPEG": "",
        "Plik JPG": "",
        "Plik MP4": "",
        "Plik PNG": "",
        "Plik skompresowany": "",
        "Plik wideo": "",
        "Plik ZIP": "",
        "Plik został dodany.": "",
        "Plik został usunięty.": "",
        "Plik został wysłany": "",
        "Plik:": "",
        "Pliki": "",
        "Pliki asystenta": "",
        "Pliki do dodania": "",
        "Pliki do wysłania: %0": "",
        "Pliki prywatne": "",
        "Pliki publiczne": "",
        "Pliki współdzielone": "",
        "Pliki: %0": "",
        "Płatności": "",
        "Płeć": "",
        "Płyta z muzyką": "",
        "po %0 nieudanych próbach logowania": "",
        "Po aktywacji wejście na dowolną stronę frontową przez użytkownika w obrębie witryny wyświetli informację o trwającej przerwie technicznej. Witryna podczas przerwy technicznej dla użytkowników z uprawnieniami administratora jest zawsze dostępna.": "",
        "Po jednym synonimie w wierszu": "",
        "Po upływie tego czasu (liczonego od czasu utworzenia rezerwacji) rezerwacja przestanie obowiązywać (0 - brak limitu).": "",
        "Po upływie tego czasu nie bedzie można złożyć reklamacji. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane. ": "",
        "Po upływie tego czasu nie bedzie można złożyć zwrotu. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane.": "",
        "Po wybraniu artykułu \"Opinia\", etykieta zostanie ustawiona automatycznie jako \"OPINIA\".": "",
        "Po wybraniu opcji \"Artykuł sponsorowany\", etykieta zostanie ustawiona automatycznie jako \"ARTYKUŁ SPONSOROWANY\". Obie te etykiety nie mogą występować razem.": "",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Po zmianie krótkiego tytułu zmieni się również adres URL.": "",
        "Pobierz": "",
        "Pobierz wyniki": "",
        "Pobranie": "",
        "Początkowa ilość wierszy": "",
        "Poczta": "",
        "Podaj adres url...": "",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "",
        "Podaj kod weryfikacyjny": "",
        "Podaj nową nazwę": "",
        "Podaj swój adres email": "",
        "Podana nazwa jest zajęta.": "",
        "Podana wartość jest nieprawidłowa.": "",
        "Podanie nazwy jest wymagane.": "",
        "Podano adres": "",
        "Podano nieprawidłowe dane": "",
        "Podano nieprawidłowe dane.": "",
        "Podano nieprawidłowe dane. (%0)": "",
        "Podatki": "",
        "Podążanie za linkami": "",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "",
        "Podgląd": "",
        "Podgląd artykułu": "",
        "Podgląd formularza": "",
        "Podgląd strony": "",
        "Podgląd tabeli": "",
        "Podkreślenie": "",
        "Podłącz linki wewnętrzne": "",
        "Podpis": "",
        "Podstawowe": "",
        "Podstawowe operacje na datach": "",
        "Podstawowe operacje na liczbach": "",
        "Podstawowe operacje tekstowe": "",
        "Podstawowe operacje warunkowe": "",
        "Podziedziałek - Piątek": "",
        "Pojedynczy artykuł (strona opisowa)": "",
        "Pojedynczy wybór": "",
        "Pokaż etykietę": "",
        "Pokaż historię": "",
        "Pokaż kafelki do ostatniego poziomu": "",
        "Pokaż kafelki do wybranego poziomu": "",
        "Pokaż numery stron": "",
        "Pokaż przycisk ``Wyślij``": "",
        "Pokaż szczegóły": "",
        "Pokaż tylko moje dokumenty": "",
        "Pokaż tytuł formularza": "",
        "Pokaż tytuł sekcji": "",
        "Pokaż tytuł strony": "",
        "Pokaż tytuły stron": "",
        "Pokaż w koncie użytkownika": "",
        "Pokaż więcej": "",
        "pokaż więcej...": "",
        "Pole \"%0\" jest wymagane.": "",
        "Pole \"%0\" jest wymagane. (%1)": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "",
        "Pole \"Drugie imię\" jest wymagane.": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Imię\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole \"Nazwisko\" jest wymagane.": "",
        "Pole \"Tytuł\" jest wymagane.": "",
        "Pole jest wymagane": "",
        "Pole może zawierać jedynie cyfry.": "",
        "Pole może zawierać jedynie cyfry. (%0)": "",
        "Pole może zawierać jedynie litery i cyfry.": "",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "",
        "Pole może zawierać jedynie litery.": "",
        "Pole może zawierać jedynie litery. (%0)": "",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "",
        "Pole nie może zawierać spacji": "",
        "Pole skopiowane": "",
        "Pole tekstowe": "",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "",
        "Pole wymaga podania przynajmniej jednej cyfry.": "",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "",
        "Pole wymaga podania przynajmniej jednej małej litery.": "",
        "Pole wymagane": "",
        "Pole zawiera": "",
        "Polecane artykuły": "",
        "Polityka prywatności": "",
        "Polski": "",
        "Pomoc": "",
        "Poniedziałek": "",
        "Poprawne": "",
        "Poprawny": "",
        "Poprzednia strona": "",
        "Popularność": "",
        "Porównaj %0": "",
        "Porównaj z edytowaną wersją": "",
        "Porównania": "",
        "Porównanie": "",
        "Porównywana wersja": "",
        "Port": "",
        "Posiada załączniki": "",
        "POST: Lista wpisów (dowolne wyszukiwanie)": "",
        "POST: Upload załączników": "",
        "POST: Utworzenie wpisu": "",
        "POST: Zapisanie zmian": "",
        "Potwierdzenia": "",
        "Potwierdzenie mailowe": "",
        "Potwierdzenie mailowe i akceptacja administratora": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie włączenia": "",
        "Potwierdzenie wylogowania użytkownika": "",
        "Potwierdzenie wyłączenia": "",
        "Potwierdzenie wysłania": "",
        "Potwierdzenie zatwierdzenia": "",
        "Potwierdzenie zmiany statusu": "",
        "Potwierdzone": "",
        "Potwierdź": "",
        "Potwierdź akceptację": "",
        "Potwierdź przywrócenie wersji roboczej": "",
        "Potwierdź publikację wersji": "",
        "Potwierdź usunięcie": "",
        "Potwierdź usunięcie wybranej wersji aranżacji": "",
        "Potwierdź wyłączenie publikacji": "",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienia zostały skonfigurowane.": "",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiązana galeria": "",
        "Powiązana kategoria": "",
        "Powiązane artykuły": "",
        "Powiązane galerie": "",
        "Powiązane kategorię": "",
        "Powiązane wideo": "",
        "Powiązany artykuł": "",
        "Powiązany autor": "",
        "Powiększ": "",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "",
        "Powód": "",
        "powrót": "",
        "Powrót": "",
        "Powtórz hasło": "",
        "Powtórzone": "",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "",
        "Poziom dostępu do webhooka": "",
        "Poziom dostępu użytkownika": "",
        "Pozostałe": "",
        "Pozostałe ustawienia": "",
        "Pozostało %0 znaków.": "",
        "Pozwól na dodawanie wierszy": "",
        "Pozwól zamawiać": "",
        "Pozycja": "",
        "pół roku": "",
        "Prawy panel": "",
        "Predefiniowane tła panelu z aplikacjami": "",
        "Predefiniowane zestawy kolorów": "",
        "Premiera": "",
        "Premium": "",
        "Premium otwarty": "",
        "Priorytet": "",
        "private (tylko cache przeglądarki)": "",
        "Procent": "",
        "Produkcyjne": "",
        "Profil użytkownika": "",
        "Profil został zaktualizowany.": "",
        "Projekt": "",
        "Prometheus": "",
        "Proporcje obrazu": "",
        "Proste uprawnienia": "",
        "Protokół OAuth - client_id": "",
        "Protokół OAuth - client_secret": "",
        "Protokół OAuth - clientId": "",
        "Protokół OAuth - clientSecret": "",
        "Próbkowanie": "",
        "Prywatne": "",
        "Przebudowanie indeksów": "",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "",
        "Przeciągnij do innej sekcji": "",
        "Przeciągnij do wybranej sekcji": "",
        "Przeciągnij i upuść aby posortować pliki": "",
        "Przeczytane": "",
        "Przedrostek": "",
        "Przedtytuł": "",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
        "Przeindeksowanie danych": "",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "",
        "Przekierowania": "",
        "Przekierowanie aktywne": "",
        "Przekierowanie zostało dodane.": "",
        "Przekierowanie zostało usunięte.": "",
        "Przekierowanie zostało zaktualizowane.": "",
        "Przekroczono dozwoloną ilość znaków: %0.": "",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "",
        "Przelew tradycyjny": "",
        "Przelewy24": "",
        "Przełącznik": "",
        "Przeniesienie wybranych elementów": "",
        "przeniesiony do kosza": "",
        "Przenieś": "",
        "Przenieś do sekcji": "",
        "Przenieś niżej": "",
        "Przenieś wyżej": "",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "przeniósł do kosza": "",
        "Przepisz limit konta oraz aktualne stawki za 1000 tokenów ze strony OpenAI.": "",
        "Przepnij alias": "",
        "Przerwa techniczna": "",
        "Przesuń do góry": "",
        "Przesuń na dół": "",
        "Przesuń w dół": "",
        "Przesyłanie plików powiodło się.": "",
        "Przetestuj": "",
        "Przetestuj poprawność zapisanych kluczy": "",
        "Przetestuj ustawienia poczty": "",
        "Przetestuj ustawienia Sms": "",
        "Przetwarzane": "",
        "Przybornik": "",
        "Przykład:": "",
        "Przykład: ^\\d{5}$": "",
        "Przykład: 00000": "",
        "Przykład: domena\\użytkownik": "",
        "Przykład: użytkownik@domena": "",
        "Przykładowa struktura danych": "",
        "Przykłady": "",
        "Przykłady konfiguracji": "",
        "Przypisanie do zespołu": "",
        "Przypisanie ról": "",
        "Przyrostek": "",
        "Przywrócenie": "",
        "przywrócił z kosza": "",
        "przywrócony z kosza": "",
        "Przywróć": "",
        "Przywróć domyślne": "",
        "Przywróć filtr": "",
        "Przywróć${checkedItems.length > 1 ? ' zaznaczone' : ''}": "",
        "Przyznaj dostęp": "",
        "Pseudonim": "",
        "public (cache przeglądarki i proxy)": "",
        "Publiczne": "",
        "Publiczne ID:": "",
        "Publikacja": "",
        "Publikacja aranżacji została wyłączona.": "",
        "Publikacja artykułu": "",
        "Publikacja galerii przez użytkownika": "",
        "Publikacja priorytetowa": "",
        "Publikacja zarchiwizowana": "",
        "Publikacja została dodana.": "",
        "Publikacja została usunięta.": "",
        "Publikuj do": "",
        "Publikuj na stronie": "",
        "Publikuj na wybranej stronie": "",
        "Publikuj od": "",
        "PUT: Aktualizacja wpisu": "",
        "Pytania": "",
        "Pytania i odpowiedzi": "",
        "Pytanie": "",
        "Query string": "",
        "Radio": "",
        "Ranga": "",
        "Recaptcha": "",
        "ReCaptcha": "",
        "Redaktor został zaktualizowany.": "",
        "Region": "",
        "Regulamin wymagany": "",
        "Regulamin został dodany.": "",
        "Regulamin został zaktualizowany.": "",
        "Regulaminy": "",
        "Reguła podatku": "",
        "Rejestr zmian": "",
        "Rejestracja konta": "",
        "Relacyjne": "",
        "Repozytorium plików": "",
        "Request body": "",
        "Resetuj": "",
        "Resetuj zmiany": "",
        "RESTful API": "",
        "Reżyseria": "",
        "Ręczna akceptacja wszystkich komentarzy": "",
        "Rodzaj adresu kanonicznego": "",
        "Rodzaj odpowiedzi": "",
        "Rodzaj źródła": "",
        "rok": "",
        "Rok": "",
        "Rola": "",
        "Rola aktywna": "",
        "Rola domyślna": "",
        "Rola została dodana.": "",
        "Rola została usunięta.": "",
        "Rola została zaktualizowana.": "",
        "Role i uprawnienia": "",
        "Role użytkownika": "",
        "Role zespołu": "",
        "Role zostały przypisane": "",
        "Root": "",
        "Rotator": "",
        "Rotator został dodany.": "",
        "Rotator został usunięty.": "",
        "Rotator został zaktualizowany.": "",
        "Rotatory opinii": "",
        "Rozdzielczość": "",
        "Rozdzielczość wygnerowanego obrazu.": "",
        "Rozmiar": "",
        "Rozmiar okna popup": "",
        "Rozmiar pliku": "",
        "Rozmiar podawany w bajtach.": "",
        "Rozmiar zdjęcia został zmieniony.": "",
        "Rozmieść równomiernie": "",
        "Rozwiń do": "",
        "Równość": "",
        "RSS": "",
        "Satysfakcja": "",
        "Scenariusz": "",
        "Scrollowalne okna popup": "",
        "Sekcja": "",
        "Sekcja %0": "",
        "Sekcja modułu": "",
        "Sekcja pod artykułem": "",
        "Sekcja śródtekstowa": "",
        "Sekcje": "",
        "Sekcje i bloki": "",
        "SenderId": "",
        "Sentry": "",
        "Separator elementów w tytule": "",
        "Serial telewizyjny": "",
        "Server Side Cache": "",
        "Serwer bazy danych": "",
        "Serwer dostępny": "",
        "Serwer plików": "",
        "Serwer został dodany.": "",
        "Serwer został usunięty.": "",
        "Serwer został zaktualizowany.": "",
        "Serwery plików": "",
        "Sesja": "",
        "Sesja nr %0": "",
        "Sesja użytkownika": "",
        "Sheduler": "",
        "Sierpień": "",
        "Skala 1-5": "",
        "Sklep": "",
        "Sklep został usunięty.": "",
        "Sklepy": "",
        "Skopiowano": "",
        "Skopiuj kod": "",
        "Skrócony opis": "",
        "Skrypt": "",
        "Skrypty zewnętrzne": "",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "",
        "Slajder": "",
        "Slajder został dodany.": "",
        "Slajder został usunięty.": "",
        "Slajder został zaktualizowany.": "",
        "Slajdery": "",
        "słowa": "",
        "Słowa kluczowe": "",
        "Słowa oddzielone przecinkami.": "",
        "Słowa wykluczone": "",
        "Słownik": "",
        "Słownik dowolny": "",
        "Słownik systemowy": "",
        "Słowo": "",
        "Słowo bazowe": "",
        "Słowo wykluczone": "",
        "Słowo zostało dodane.": "",
        "Słowo zostało usunięte.": "",
        "Słowo zostało zaktualizowane.": "",
        "Sobota": "",
        "Sortowanie": "",
        "Sortowanie autorów": "",
        "Sortowanie cech": "",
        "Sortowanie grup cech": "",
        "Sortowanie kategorii": "",
        "Sortowanie malejąco": "",
        "Sortowanie rosnąco": "",
        "Sortowanie wartości": "",
        "Sortuj autorów": "",
        "Sortuj cechy": "",
        "Sortuj grupy cech": "",
        "Sortuj kategorie": "",
        "Sortuj wartości": "",
        "Specjalizowane": "",
        "Specyfikacja": "",
        "Sposób dostawy": "",
        "Sposób dostawy włączony": "",
        "Sposób dostawy został dodany.": "",
        "Sposób dostawy został usunięty.": "",
        "Sposób dostawy został zaktualizowany.": "",
        "Sposób płatności włączony": "",
        "Sposób płatności został dodany.": "",
        "Sposób płatności został usunięty.": "",
        "Sposób płatności został zaktualizowany.": "",
        "Sposób prezentacji zakładek": "",
        "Sposób wyświetlania kafelków kategorii w katalogu produktów": "",
        "Sprawdzenie czy pusty": "",
        "Stała wartość": "",
        "Stan powiadomienia": "",
        "Standardowa strona": "",
        "Standardowa szczegółowość": "",
        "Standardowe uprawnienia": "",
        "Stara cena brutto": "",
        "Start": "",
        "Status": "",
        "Status aranżacji został zmieniony.": "",
        "Status baneru został zmieniony.": "",
        "Status dokumentu został zmieniony.": "",
        "Status edytowanej wersji dokumentu": "",
        "Status galerii został zmieniony.": "",
        "Status linku został zmieniony.": "",
        "Status modułu": "",
        "Status płatności": "",
        "Status regulaminu został zmieniony.": "",
        "Status webhooka": "",
        "Status wideo został zmieniony.": "",
        "Status zamówienia": "",
        "Status żądania": "",
        "Status:": "",
        "Statyczny": "",
        "Stawka aktywne": "",
        "Stawka domyślna": "",
        "Stawka została dodana.": "",
        "Stawka została usunięta.": "",
        "Stawka została zaktualizowana.": "",
        "Stawki podatku w poszczególnych państwach": "",
        "Stopka": "",
        "Strefa czasowa": "",
        "Strona": "",
        "Strona %0": "",
        "Strona bez modułu": "",
        "Strona błędu": "",
        "Strona docelowa dla 'Czytaj więcej'": "",
        "Strona docelowa dla 'Kontakt z adminem'": "",
        "Strona docelowa dla 'Pliki cookies'": "",
        "Strona docelowa dla 'Polityka prywatności'": "",
        "Strona dostępna dla wszystkich": "",
        "Strona dostępna tylko dla zalogowanych użytkowników": "",
        "Strona główna": "",
        "Strona logowania": "",
        "Strona nadrzędna": "",
        "Strona opublikowana": "",
        "Strona ukryta": "",
        "Strona z błędem 404": "",
        "Strona z modułu konto użytkownika": "",
        "Strona z modułu wyszukiwarki": "",
        "Strona została dodana.": "",
        "Strona została usunięta.": "",
        "Strona została zaktualizowana.": "",
        "Strony": "",
        "Strony gazetki": "",
        "Struktura organizacyjna": "",
        "Struktura serwisu": "",
        "Studio": "",
        "Stwierdzenie": "",
        "Styczeń": "",
        "Styl obrazu": "",
        "Subskrypcja": "",
        "Subskrypcja aktywna": "",
        "Subskrypcje": "",
        "Sukces": "",
        "Suma danych wejściowych i wyjściowych podana w tokenach.": "",
        "Suma tokenów": "",
        "Symbol": "",
        "Symbol autora": "",
        "Symbol jest wymagany": "",
        "Symbol jest zajęty": "",
        "Symbol kategorii": "",
        "Symbol klienta": "",
        "Symbol linku": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol musi mieć co najmniej 3 znaki": "",
        "Symbol musi mieć co najmniej 5 znaków": "",
        "Symbol nie może być dłuższy niż 10 znaków": "",
        "Symbol nie może być dłuższy niż 20 znaków": "",
        "Symbol strony": "",
        "Symbol w adresie URL": "",
        "Synchronizuj": "",
        "Synonimy": "",
        "Synonimy zostały dodane.": "",
        "Synonimy zostały usunięte.": "",
        "Synonimy zostały zaktualizowane.": "",
        "System": "",
        "System powiadomień": "",
        "Szablon graficzny": "",
        "Szablon modułu": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony": "",
        "Szacowana kwota:": "",
        "Szczegółowość obrazu": "",
        "Szczegóły": "",
        "Szczegóły asystenta": "",
        "Szczegóły elementu": "",
        "Szczegóły klienta": "",
        "Szczegóły wartości": "",
        "Szczegóły wpisu": "",
        "Szczegóły zadania": "",
        "Szczegóły zamówienia": "",
        "Szczegóły zapytania": "",
        "Szczegóły zdarzenia": "",
        "Szczegóły zdarzenia nr %0": "",
        "Szerokość": "",
        "Szerokość strony": "",
        "Szkic": "",
        "Szukaj": "",
        "Szukaj we wszystkich wersjach": "",
        "Szukana fraza": "",
        "Szukane słowo": "",
        "Ścieżka aktywnej strony": "",
        "Ścieżka nawigacyjna": "",
        "Średni": "",
        "Środa": "",
        "Środowisko": "",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "",
        "Tabela": "",
        "Tagi": "",
        "Tak": "",
        "Tak/Nie": "",
        "Target": "",
        "Tekst": "",
        "Tekst alternatywny": "",
        "Tekst lokalizowany": "",
        "Tekst wyświetlany podczas ustawienia blokady": "",
        "Tekst zastępczy": "",
        "Tekstowy / HTML / JS": "",
        "Telefon": "",
        "Ten dashboard nie zawiera jeszcze żadnych widgetów": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Tenant ID": "",
        "Teraz": "",
        "Terminy dla kończących się subskrypcji": "",
        "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "",
        "Test konfiguracji": "",
        "Test ustawień pomyślnie zakończony.": "",
        "Testowe": "",
        "Testowy adres email": "",
        "Testowy numer telefonu": "",
        "Testuj": "",
        "Testuj zapytanie": "",
        "Tłumaczenia": "",
        "To pole jest wymagane": "",
        "Token": "",
        "Token został usunięty.": "",
        "Tokeny": "",
        "Tokeny dostępu": "",
        "Tokeny wejściowe": "",
        "Tokeny wyjściowe": "",
        "Top temat został dodany.": "",
        "Top temat został usunięty.": "",
        "Top temat został zaktualizowany.": "",
        "Top tematy": "",
        "Tracing": "",
        "Treści odpowiedzi są wymagane": "",
        "Treści pytań są wymagane": "",
        "Treść": "",
        "Treść komentarza": "",
        "Treść nie może być pusta.": "",
        "Trigger": "",
        "Trwa generowanie formularza": "",
        "Trwa generowanie obrazów": "",
        "Trwa generowanie obrazu": "",
        "Trwa generowanie opisu dla wybranego obrazu": "",
        "Tryb konserwacji systemu": "",
        "Tryb wyświetlania": "",
        "Trzy kolumny": "",
        "Twoje hasło wygasło. Zmień je na nowe.": "",
        "Tworzenie dokumentów": "",
        "Twój token": "",
        "tydzień": "",
        "Tydzień": "",
        "Tylko 404": "",
        "Tylko aktywne": "",
        "Tylko do odczytu": "",
        "tylko dokumenty wersjonowane": "",
        "Tylko gdy odpowiedź serwera jest 404": "",
        "Tylko liderzy": "",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "",
        "Tylko priorytetowe": "",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "",
        "Tylko treść": "",
        "Tylko zalogowani użytkownicy mogą zgłaszać komentarze": "",
        "Typ": "",
        "Typ aranżacji": "",
        "Typ autora": "",
        "Typ bannera": "",
        "Typ długości": "",
        "Typ długości pakietu": "",
        "Typ konta": "",
        "Typ logowania": "",
        "Typ mime": "",
        "Typ obiektu": "",
        "Typ obiektu:": "",
        "Typ pakietu": "",
        "Typ pliku": "",
        "Typ pola": "",
        "Typ powiadomienia": "",
        "Typ rankingu": "",
        "Typ serwera": "",
        "Typ słownika": "",
        "Typ strony": "",
        "Typ właściwy": "",
        "Typ zestawu": "",
        "Typ źródła": "",
        "Typ źródła danych": "",
        "typu \"%0\" o ID \"%1\"": "",
        "Tytuł": "",
        "Tytuł aktywnej witryny": "",
        "Tytuł elementu": "",
        "Tytuł formularza jest wymagany": "",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "",
        "Tytuł okładki": "",
        "Tytuł przerwy technicznej": "",
        "Tytuł sekcji": "",
        "Tytuł strony": "",
        "Tytuł witryny": "",
        "Udało się zapisać ustawienia widgetów": "",
        "Układ": "",
        "Układ listy": "",
        "Ukryj kafelki": "",
        "Ukryta": "",
        "Ukryty": "",
        "Ulica": "",
        "Upload": "",
        "Uprawnienia": "",
        "Uprawnienia do dokumentów": "",
        "Uprawnienia zostały usunięte.": "",
        "Url": "",
        "URL": "",
        "URL płatności": "",
        "Uruchom zadanie": "",
        "Urządzenie zostało usunięte.": "",
        "Usługi": "",
        "Ustaw kategorię": "",
        "Ustaw również dla wszystkich podstron": "",
        "Ustaw szerokości proporcjonalnie": "",
        "Ustawienia": "",
        "Ustawienia domyślne": "",
        "Ustawienia dostępności": "",
        "Ustawienia Dotpay": "",
        "Ustawienia Firebase": "",
        "Ustawienia konta": "",
        "Ustawienia limitu kupieckiego": "",
        "Ustawienia PayPal": "",
        "Ustawienia PayU": "",
        "Ustawienia płatności": "",
        "Ustawienia płatności zostały zaktualizowane.": "",
        "Ustawienia podstawowe": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Ustawienia przelewu tradycyjnego": "",
        "Ustawienia Przelewy24": "",
        "Ustawienia redakcji": "",
        "Ustawienia rotatora": "",
        "Ustawienia sekcji \"%0\"": "",
        "Ustawienia sesji": "",
        "Ustawienia sklepu": "",
        "Ustawienia slajdera": "",
        "Ustawienia strony": "",
        "ustawienia widgetu": "",
        "Ustawienia widgetu": "",
        "Ustawienia witryny": "",
        "Ustawienia zaawansowane": "",
        "Ustawienia zostały zaktualizowane.": "",
        "Ustawienia zostały zapisane.": "",
        "usunął": "",
        "Usunął": "",
        "Usunięcie": "",
        "Usunięcie dokumentu": "",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nnCzy na pewno chcesz usunąć wybrany formularz?": "",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "",
        "Usunięcie wybranych elementów": "",
        "Usunięto wybraną wersję aranżacji.": "",
        "usunięty": "",
        "Usuń": "",
        "Usuń artykuł z listy": "",
        "Usuń autora": "",
        "Usuń blok z sekcji": "",
        "Usuń cechę": "",
        "Usuń charmonogram": "",
        "Usuń datę": "",
        "Usuń dział": "",
        "Usuń filtr": "",
        "Usuń grupę": "",
        "Usuń indeks": "",
        "Usuń katalog": "",
        "Usuń kategorię": "",
        "Usuń odpowiedź": "",
        "Usuń opinię": "",
        "Usuń plik": "",
        "Usuń plik z listy": "",
        "Usuń powiązanie": "",
        "Usuń powód": "",
        "Usuń pozycję": "",
        "Usuń publikację": "",
        "Usuń pytanie": "",
        "Usuń regulamin": "",
        "Usuń sekcję": "",
        "Usuń slajd": "",
        "Usuń słowo": "",
        "Usuń spacje": "",
        "Usuń stronę": "",
        "Usuń tag": "",
        "Usuń urządzenie": "",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "",
        "Usuń wybraną wersję aranżacji": "",
        "Usuń wybrany element": "",
        "Usuń z zespołu": "",
        "Usuń zestaw": "",
        "Usuń${checkedItems.length > 1 ? ' zaznaczone' : ''}": "",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "Usuwanie dokumentów": "",
        "Usuwanie użytkowników": "",
        "Usuwanie własnych dokumentów": "",
        "Usuwanie wszystkich dokumentów": "",
        "Utworzył": "",
        "Utwórz grupy": "",
        "Utwórz katalog": "",
        "Utwórz kopię formularza": "",
        "Utwórz kopię z": "",
        "Utwórz nowy": "",
        "Utwórz nowy wątek": "",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "",
        "Uwzględnij dodatkowe koszty pakowania produktów": "",
        "Uwzględnij wydziały podrzędne": "",
        "Użyte narzędzie": "",
        "Użytkownicy": "",
        "Użytkownicy mogą zgłaszać komentarze do moderacji": "",
        "Użytkownicy w tej roli": "",
        "Użytkownik": "",
        "Użytkownik \"%0\" %1 obiekt %2": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik nie należy do żadnego zespołu.": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik z bazy": "",
        "Użytkownik zalogowany": "",
        "Użytkownik został dodany do zespołu.": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został wylogowany.": "",
        "Użytkownik został zaktualizowany.": "",
        "Użytkownik został zanonimizowany.": "",
        "Użytkownikcy z bazy": "",
        "Użyty Model": "",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "",
        "W każdy dzień tygodnia": "",
        "W organizacji nie ma jeszcze żadnych działów.": "",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "",
        "W przyszłości": "",
        "W tym katalogu nie ma jeszcze żadnych kategorii.": "",
        "W tym katalogu nie ma jeszcze żadnych stron.": "",
        "W zespole od %0": "",
        "W zespole od %0 do %1": "",
        "Waga": "",
        "Walidacja": "",
        "Walidacja certyfikatu SSL": "",
        "Walidacja danych": "",
        "Walidacja po stronie API": "",
        "Walidacja typów MIME": "",
        "Waluta": "",
        "Waluta została dodana.": "",
        "Waluta została zaktualizowana.": "",
        "Waluty": "",
        "Wartości cechy": "",
        "Wartości liczbowa": "",
        "Wartości numeryczne": "",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "",
        "Wartości tekstowa": "",
        "Wartości wymagana": "",
        "Wartość": "",
        "Wartość długości": "",
        "Wartość domyślna": "",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "",
        "Wartość domyślna: (&(objectClass=user)": "",
        "Wartość musi być liczbą całkowitą": "",
        "Wartość musi być liczbą dodatnią": "",
        "Wartość musi być liczbą ujemną": "",
        "Wartość numeryczna": "",
        "Wartość tekstowa": "",
        "Wartość została dodana.": "",
        "Wartość została zaktualizowana.": "",
        "Warunki korzystania z usług Google": "",
        "Warunki logiczne": "",
        "Warunkowo": "",
        "Ważne informacje": "",
        "Ważne: Moduł ten obsługuje wyłącznie linki wewnętrzne, tj. odnoszące się do zasobów w ramach tej samej domeny i serwisu. Adresy należy podawać jako pełne ścieżki, na przykład: /stara-strona oraz /nowa-strona.": "",
        "Ważność": "",
        "Wątek": "",
        "Wątek główny": "",
        "Wątek główny jest kontynuowany automatycznie przez asystenta.": "",
        "Wczytywanie danych...": "",
        "Webhook": "",
        "Webhook został dodany.": "",
        "Webhook został usunięty.": "",
        "Webhook został zaktualizowany.": "",
        "Webhooki": "",
        "Weekend": "",
        "Wersja API": "",
        "Wersja językowa": "",
        "Wersja nieopublikowana": "",
        "Wersja opublikowana": "",
        "Wersja robocza została przywrócona.": "",
        "Wersja utowrzona przez": "",
        "Wersje": "",
        "Wersje aranżacji": "",
        "Wersje dokumentu": "",
        "wersji zaakceptowanej": "",
        "Wersjonowanie": "",
        "Wersjonowanie dokumentów włączone": "",
        "Wersjonowanie dokumentów wyłączone": "",
        "Wersjonowanie można włączyć tylko podczas dodawania nowego formularza.": "",
        "Wewnętrznie": "",
        "Wewnętrzny": "",
        "Wiadomość testowa została wysłana.": "",
        "Wiadomość została wysłana.": "",
        "Wideo": "",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "",
        "Wideo nie ma ustawionej daty publikacji.": "",
        "Wideo premium": "",
        "Wideo zostało dodane.": "",
        "Wideo zostało usunięte.": "",
        "Wideo zostało zaktualizowane.": "",
        "Widgety": "",
        "Widoczność": "",
        "Widoczność modułu w menu": "",
        "Widoczność sekcji w menu modułu": "",
        "Widoczny obszar": "",
        "Widok czołówki - zdjęcie z tytułem": "",
        "Widok ustawień": "",
        "Wielkość kroku": "",
        "Wielokrotny wybór": "",
        "Wiersz": "",
        "Więcej": "",
        "więcej...": "",
        "Więcej...": "",
        "Witryna": "",
        "Witryna / Wersja językowa": "",
        "Witryna aktywna": "",
        "Witryna domyślna": "",
        "Witryna i język": "",
        "Witryna internetowa": "",
        "Witryna tylko dla zalogowanych użytkowników": "",
        "Witryna została dodana.": "",
        "Witryna została usunięta.": "",
        "Witryna została zaktualizowana.": "",
        "Witryny": "",
        "Wklej komponent": "",
        "Właściwości": "",
        "Właściwości szablonu": "",
        "Właściwość ``%0`` aktywnego wpisu": "",
        "Włącz": "",
        "Włącz ankietę": "",
        "Włącz formularz kontaktowy": "",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "",
        "Włącz social media": "",
        "Włącz system komentarzy": "",
        "Włącz walidację po stronie API": "",
        "Włącza bardzo restrykcyjne sprawdzanie typów MIME dla wysyłanych plików. W przypadku zgłaszania błędów dla plików, których zawartości jesteśmy pewni, należy tą opcję pozostawić nieaktywną.": "",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "",
        "Włączenie moderacji danych wejściowych jest zalecane.": "",
        "Włączenie obsługi cacheu dla witryny": "",
        "Włączenie protokołu SSL dla tej witryny": "",
        "Włączone": "",
        "Włączone (Follow)": "",
        "Włączone (Index)": "",
        "Włączony": "",
        "Województwo": "",
        "Wpis aktywny": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wpis do kalendarza został zaktualizowany.": "",
        "Wpis domyślny": "",
        "Wpis w kalendarzu został dodany.": "",
        "Wpis w kalendarzu został zaktualizowany.": "",
        "Wpis został dodany.": "",
        "Wpis został usunięty.": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisy zostały usunięte.": "",
        "Wpisy zostały zaakceptowane.": "",
        "Wpisz adresy po przecinku.": "",
        "Wpisz wiadomość": "",
        "Wpływ na wariantowość produktu": "",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "",
        "Wprowadzona wartość jest nieprawidłowa": "",
        "Wprowadzona wartość jest za długa": "",
        "Wprowadzona wartość jest za krótka": "",
        "Wprowadzona wartość jest za niska": "",
        "Wprowadzona wartość jest za wysoka": "",
        "Wprowadzona wartość nie jest poprawna": "",
        "Wprowadź link": "",
        "Wróć do logowania": "",
        "Wróć do strony głównej": "",
        "Wrzesień": "",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "",
        "Wstaw cztery kolumny 1/4": "",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "",
        "Wstaw dwie równe kolumny": "",
        "Wstaw kontrolkę": "",
        "Wstaw stronę": "",
        "Wstaw szablon informacyjny ze zdjęciem": "",
        "Wstaw trzy kolumny 1/3": "",
        "Wstaw z dołu": "",
        "Wstaw z góry": "",
        "Wstaw z lewej strony": "",
        "Wstaw z prawej strony": "",
        "Wstecz": "",
        "Wstęp": "",
        "Wstępne filtrowanie danych": "",
        "Wszystkie": "",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "",
        "Wszystkie kraje": "",
        "Wszystkie niezapisane zmiany zostaną utracone.": "",
        "Wszystkie próby": "",
        "Wszystko": "",
        "Wtorek": "",
        "wybierz": "",
        "Wybierz": "",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "",
        "Wybierz ankietę": "",
        "Wybierz artykuł": "",
        "Wybierz autora": "",
        "Wybierz blok": "",
        "Wybierz cechę": "",
        "Wybierz czołówkę": "",
        "Wybierz datę": "",
        "Wybierz datę lub wprowadź wartość tekstową": "",
        "Wybierz daty publikacji": "",
        "wybierz długość": "",
        "Wybierz domyślną kategorię": "",
        "Wybierz formularz": "",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "",
        "Wybierz galerię": "",
        "Wybierz istniejącego użytkownika": "",
        "wybierz katalog": "",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "",
        "Wybierz kategorię": "",
        "Wybierz kategorię subskrypcji": "",
        "Wybierz link z serwisu": "",
        "Wybierz listę regulaminów": "",
        "wybierz model": "",
        "Wybierz plik": "",
        "Wybierz plik lub katalog": "",
        "Wybierz plik.": "",
        "Wybierz pliki": "",
        "Wybierz pliki (do {0})": "",
        "Wybierz poziom": "",
        "Wybierz regulamin": "",
        "Wybierz sekcję": "",
        "Wybierz serwer": "",
        "Wybierz shortcode": "",
        "Wybierz stronę": "",
        "Wybierz stronę do opublikowania": "",
        "Wybierz strony": "",
        "wybierz szablon": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "",
        "Wybierz użytkownika": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wybierz wątek w którym chcesz prowadzić konwersację.": "",
        "Wybierz wideo": "",
        "Wybierz zakres godzinowy": "",
        "Wybierz zaznaczone": "",
        "wybierz...": "",
        "Wybierz...": "",
        "Wybór": "",
        "Wybór języka": "",
        "Wybór listy stron": "",
        "Wybór strony": "",
        "Wybór+": "",
        "Wybrana data jest mniejsza niż dozwolona %0.": "",
        "Wybrana data jest większa niż dozwolona %0.": "",
        "Wybrana ikona powinna być kwadratem": "",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "",
        "Wybrana liczba jest większa niż dozwolona %0.": "",
        "Wybrane": "",
        "Wybrane artykuły": "",
        "Wybrane dokumenty": "",
        "Wybrane elementy zostały przeniesione.": "",
        "Wybrane elementy zostały usunięte.": "",
        "wybrane elementy?": "",
        "Wybrane pliki": "",
        "Wybrane pliki: {0}": "",
        "Wybrane regulaminy:": "",
        "Wybrane: %0": "",
        "Wybranie ankiety jest wymagane": "",
        "Wybranie katalogu jest wymagane": "",
        "Wybranie strony jest wymagane": "",
        "Wybrano": "",
        "Wybrano %0 użytkowników.": "",
        "Wybrano jednego użytkownika.": "",
        "Wybrany język": "",
        "Wybrany szablon": "",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "",
        "Wybróbuj możliwości AI": "",
        "Wyczyść": "",
        "Wyczyść aranżację": "",
        "Wydział": "",
        "Wygenerowana odpowiedź przez model AI.": "",
        "Wygenerowane obrazy": "",
        "Wygeneruj metadane dla przesyłanych obrazów": "",
        "Wygląd": "",
        "Wyklucz logowanie zależności": "",
        "Wykonaj": "",
        "Wykonawca": "",
        "Wykorzystane": "",
        "Wykresy": "",
        "Wyloguj się": "",
        "Wyloguj zalogowanego obecnie użytkownika": "",
        "Wyłaczone": "",
        "Wyłącz cenę": "",
        "Wyłącz cenę z historii": "",
        "Wyłącz komentarze": "",
        "Wyłącz udostępnij dalej": "",
        "Wyłączone (NoFollow)": "",
        "Wyłączone (NoIndex)": "",
        "Wyłączone komentarze": "",
        "Wyłączone przez": "",
        "Wyłączone udostępnianie": "",
        "Wyłączony": "",
        "Wymagaj ponownej akceptacji po zmianach": "",
        "Wymagaj znaków specjalnych w hasłach": "",
        "Wymagane": "",
        "Wymagane jest ustawienie minimalnej długości hasła": "",
        "Wymagane jest wybranie formularza": "",
        "Wymagane jest wybranie kategorii": "",
        "Wymagane jest wybranie komponentu": "",
        "Wymagane jest wybranie modułu": "",
        "Wymagane jest wybranie sekcji": "",
        "Wymagane jest wybranie wersji językowej": "",
        "Wymagane jest wybranie witryny": "",
        "Wymagane jest wybranie zestawu regulaminów": "",
        "Wymagane jest wybranie źródła danych": "",
        "Wymagane znaki": "",
        "Wymagany kod pocztowy": "",
        "Wymiary": "",
        "Wymuś zmianę hasła": "",
        "Wynik testu": "",
        "Wyniki": "",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "",
        "Wyniki_": "",
        "Wyrażenia warunkowe": "",
        "Wyrażenie regularne": "",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "",
        "Wyrażone zgody": "",
        "Wysłane": "",
        "Wysoka szczegółowość": "",
        "Wysoki": "",
        "Wysokość": "",
        "Wysokość strony": "",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "",
        "Wystąpił błąd podczas próby exportu przekierowań.": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby importu definicji modułu.": "",
        "Wystąpił błąd podczas próby importu przekierowań.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił problem podczas przesyłania obrazu.": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wysyłaj dane o użytkowniku": "",
        "Wysyłaj tym kanałem": "",
        "Wyszukaj (Ctrl+Q)": "",
        "Wyszukaj albo dodaj nową kategorię": "",
        "Wyszukaj albo dodaj nowy tag": "",
        "Wyszukaj autora...": "",
        "Wyszukaj blok": "",
        "Wyszukaj czołówkę...": "",
        "Wyszukaj formularz...": "",
        "Wyszukaj kategorię": "",
        "Wyszukaj regulamin...": "",
        "Wyszukaj tag": "",
        "wyszukaj użytkownika...": "",
        "Wyszukaj użytkownika...": "",
        "Wyszukaj widget": "",
        "Wyszukaj wszędzie": "",
        "Wyszukaj...": "",
        "Wyszukiwanie": "",
        "Wyszukiwanie plików": "",
        "Wyszukiwanie plików umożliwia asystentowi korzystanie z wiedzy z plików. Po przesłaniu pliku asystent automatycznie decyduje, kiedy pobrać treść, na podstawie żądań użytkownika.": "",
        "Wyszukiwany ciąg znaków": "",
        "Wyślij": "",
        "Wyślij kod": "",
        "Wyślij link do potwierdzenia maila": "",
        "Wyślij powiadomienie - Ilość dni po zakończeniu subskrypcji:": "",
        "Wyślij powiadomienie - Ilość dni przed zakończeniem subskrypcji:": "",
        "Wyślij wiadomość": "",
        "Wyświetlaj artykuł na całą stronę": "",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "",
        "Wyświetlaj nazwę bloczka": "",
        "Wyświetlaj opinie z tłem": "",
        "Wyświetlaj tylko treść": "",
        "Wyświetlaj tytuł": "",
        "Wyświetlam": "",
        "Wyświetlanie dokumentów": "",
        "Wytnij": "",
        "Wywołanie funkcji": "",
        "Wyzeruj licznik": "",
        "Wyżej": "",
        "Wzorzec": "",
        "Wzór kodu pocztowego": "",
        "Wzór kodu pocztowego, który będzie wyświetlany w komunikacie błędnej walidacji": "",
        "YouTube (ID)": "",
        "Z uprawnieniami": "",
        "Z uprawnieniami do modułu": "",
        "Zaakceptowany": "",
        "Zaawansowane polecenia": "",
        "Zaawansowane uprawnienia": "",
        "Zabierz dostęp": "",
        "Zablokowany": "",
        "Zablokuj": "",
        "Zachowaj oryginalny format obrazów": "",
        "zacznij pisać aby wyszukać ankietę...": "",
        "zacznij pisać aby wyszukać ankiety...": "",
        "zacznij pisać aby wyszukać artykuł...": "",
        "zacznij pisać aby wyszukać autora...": "",
        "zacznij pisać aby wyszukać cechę...": "",
        "zacznij pisać aby wyszukać galerię...": "",
        "zacznij pisać aby wyszukać grupę...": "",
        "zacznij pisać aby wyszukać kategorię...": "",
        "zacznij pisać aby wyszukać kraj...": "",
        "zacznij pisać aby wyszukać podatek...": "",
        "zacznij pisać aby wyszukać rotator...": "",
        "zacznij pisać aby wyszukać slajder...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zacznij pisać aby wyszukać użytkownika...": "",
        "zacznij pisać aby wyszukać walutę...": "",
        "zacznij pisać aby wyszukać wideo...": "",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "",
        "Zaczyna sie od": "",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "",
        "Zadanie zostało uruchomione.": "",
        "Zadanie zostało włączone": "",
        "Zadanie zostało wyłączone": "",
        "Zagrożenie": "",
        "Zaimportowano definicję modułu.": "",
        "Zaimportowano listę przekierowań.": "",
        "Zaimportowano listę użytkowników.": "",
        "Zakładki": "",
        "Zakolejkowane": "",
        "Zakończ edycje": "",
        "Zakończ sesję": "",
        "Zakończ sesję aby wylogować użytkownika": "",
        "Zakończone": "",
        "Zakres": "",
        "Zakres czasu": "",
        "Zaktualizowano.": "",
        "Zaktualizuj formularz": "",
        "Zależna od kontrolki": "",
        "Zalogowany": "",
        "Zaloguj się": "",
        "Zaloguj się na swoje konto": "",
        "Załączniki": "",
        "Załączniki premium": "",
        "Zamawianie bez rejestracji, przez niezalogowanych klientów": "",
        "Zamiany zostały zapisane.": "",
        "Zamknij": "",
        "Zamówienia": "",
        "Zamówienie": "",
        "Zamówienie zostało zaktualizowane.": "",
        "Zamówiony pakiet": "",
        "Zaokrąglenie": "",
        "Zapamiętaj logowanie": "",
        "Zapamiętane urządzenia": "",
        "Zapisuj logi": "",
        "Zapisywanie obrazów zakończone.": "",
        "Zapisz": "",
        "Zapisz filtr": "",
        "Zapisz i wróć": "",
        "Zapisz i zamknij": "",
        "Zapisz ustawienia": "",
        "Zapisz ustawienia widgetów": "",
        "Zapisz wartość": "",
        "Zapisz wersję roboczą": "",
        "Zapisz widget": "",
        "Zapisz wybrane": "",
        "Zapisz zmiany": "",
        "Zaplanowane": "",
        "Zapomniałeś hasła?": "",
        "Zapytanie SQL do pobrania po ID": "",
        "Zapytanie SQL do wyszukiwania": "",
        "Zarządzanie witrynami": "",
        "Zasięg": "",
        "Zastępstwa": "",
        "Zastępstwo": "",
        "Zastępstwo wygasło.": "",
        "Zastępstwo wygaśnie za 10 minut.": "",
        "Zastępstwo wygaśnie za 5 minut.": "",
        "Zastępstwo wygaśnie za minutę.": "",
        "Zastępstwo zostało dodane.": "",
        "Zastępstwo zostało usunięte.": "",
        "Zastępstwo zostało zaktualizowane.": "",
        "Zastępuje osobę": "",
        "Zastosuj zmiany w aplikacji": "",
        "Zatwierdź": "",
        "Zatwierdź${checkedItems.length > 1 ? ' zaznaczone' : ''}": "",
        "Zaufane adresy IP": "",
        "Zawiera": "",
        "Zawiera sekcje": "",
        "Zawierające jeden z wybranych tagów": "",
        "Zawsze": "",
        "Zaznacz": "",
        "Zaznacz wszystkie": "",
        "Zaznaczone": "",
        "Zaznaczone (${checkedItems.value.length})": "",
        "Zdarzenie": "",
        "Zdjęcia": "",
        "Zdjęcie": "",
        "Zdjęcie autora": "",
        "Zdjęcie dla tabletów": "",
        "Zdjęcie dla urządzeń mobilnych": "",
        "Zdjęcie główne": "",
        "Zdjęcie na okładce": "",
        "Zdjęcie użytkownika": "",
        "Zdjęcie w tle": "",
        "Zespoły": "",
        "Zespół": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zestaw": "",
        "Zestaw niestandardowy": "",
        "Zestaw został dodany.": "",
        "Zestaw został zaktualizowany.": "",
        "Zewnętrzne skrypty statystyk": "",
        "Zewnętrzne skrypty targetujące": "",
        "Zewnętrzny": "",
        "Zewnętrzny serwis": "",
        "Zgłaszanie komentarzy": "",
        "Zgłoszenia": "",
        "Zgoda": "",
        "Zmiana hasła": "",
        "Zmiana rozmiaru obrazu": "",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "",
        "Zmiany zostały zapisane.": "",
        "Zmiany zostaną zastosowane w aplikacji w przeciągu kikunastu sekund": "",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "",
        "Zmieniono ustawienia widgetu": "",
        "Zmień daty publikacji": "",
        "Zmień hasło": "",
        "Zmień nazwę": "",
        "Zmień nazwę katalogu": "",
        "Zmień nazwę pliku": "",
        "Zmień rozmiar": "",
        "Zmień status edytowanej wersji": "",
        "Zmień widok": "",
        "Zmniejsz": "",
        "zmodyfikował": "",
        "Zmodyfikował": "",
        "zmodyfikowany": "",
        "Znajdź typ bloku...": "",
        "znaki": "",
        "Znaki specialne": "",
        "Zobacz przed opublikowaniem": "",
        "Zobacz sesję użytkownika": "",
        "Zobacz szczegóły sesji użytkownika": "",
        "Zobacz szczegóły zdarzenia": "",
        "Zobacz wszystkie": "",
        "Zobacz wszystkie zastępstwa": "",
        "Został przywrócony oryginalny harmonogram": "",
        "został wysłany": "",
        "Zresetuj hasło": "",
        "Zrestartuj aplikacje": "",
        "Zrezygnowano z subskrypcji": "",
        "Zwrócony": "",
        "Źródła danych": "",
        "Źródła LDAP": "",
        "Źródło": "",
        "Źródło aktywne": "",
        "Źródło danych": "",
        "źródło danych zostało dodane.": "",
        "Źródło danych zostało zaktualizowane.": "",
        "Źródło LDAP zostało dodane.": "",
        "Źródło LDAP zostało zaktualizowane.": "",
        "Źródło URL": "",
        "źródło zostało usunięte.": "",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "",
        "Żródło danych": ""
    }
};
